<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <!-- <div slot="header">
            <strong>Vehicle Details</strong>
            <div class="card-header-actions">
              <router-link to="/addvehicleInfo">
                <button
                  class="btn btn-sm btn-primary mr-4 btn-pill"
                  v-on:click="useradd()"
                  type="button"
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </router-link>

              <button
                class="btn btn-sm btn-primary ml-4"
                v-on:click="refresh()"
                type="button"
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div> -->

          <b-row class="mb-4">
            <input type="hidden" name="isactiveId" id="isactiveId" value="" />
            <input
              type="hidden"
              name="deliveryagentmasterId"
              id="deliveryagentmasterId"
              value=""
            />

            <b-col md="7" class="my-1">
              <b-row>
                <b-col>
                  <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                    <b-input-group>
                      <b-form-input
                        v-model="vehiclefilter"
                        placeholder="Enter Vehicle ID/Number"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-button
                    @click="searchInLoadManagement()"
                    size="md"
                    variant="primary"
                    >Search</b-button
                  >
                  &nbsp;
                  <b-button @click="clearSearch()" size="md" variant="danger"
                    >Clear</b-button
                  > 
                </b-col>
              </b-row>
            </b-col>

            <b-col md="4" class="my-1">
              <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
                <b-input-group>
                  <b-form-select v-model="sortBy" :options="sortOptions">
                    <option slot="first" :value="null">-- none --</option>
                  </b-form-select>
                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    slot="append"
                  >
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" class="text-right">
              <b-button v-if="totalRows>0" @click="downloadvehiclereport()" size="md" variant="primary">
                Download
              </b-button>&nbsp;
              <b-button variant="success" @click="availablevehiclelist()"><i class="fa fa-check" aria-hidden="true"></i>
                Available Vehicle
              </b-button>
            </b-col>
          </b-row>
          <br>
          <b-col sm="12" class="text-right">
            <p>
              <b
                >Total Records :<span style="color:red;">{{
                  totalRows
                }}</span></b
              >
            </p>
          </b-col>
 
          <b-col sm="12">
            <b-table
              show-empty
              responsive
              :busy="isBusy"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :bordered="bordered"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>

              <template slot="drivername" slot-scope="row">
                <span
                  >{{ row.item.driverfirstname }}
                  {{ row.item.driverlastname }}</span
                >
              </template>
              <template slot="vehicle_no" slot-scope="row">
                <!-- <span> {{ row.item.vehicle_no }} </span> -->
                <b-button :disabled="isReadOnly"
                  size="sm"
                  @click="editinfoModal(row.item)"
                  data-toggle="tooltip"
                  title="Update Vehicle Details"
                >
                {{ row.item.vehicle_no }}
                </b-button>
              </template>
               <template slot="vehicle_origin_city" slot-scope="row">
                <!-- <span> {{ row.item. }}</span> -->
                <span v-if="row.item.vehicle_origin_city != null" :title="row.item.vehicle_origin_city">
                        {{ row.item.vehicle_origin_city.substring(0, 30) + ".." }}</span>
              </template>
              <template slot="isactive" slot-scope="row">
                <span
                  @click="!isReadOnly && toggleInfoModal(row.item)"
                  style="cursor:pointer;"
                >
                  <span
                    data-toggle="tooltip"
                    title="InActive"
                    v-if="row.item.isactive === '0'"
                  >
                    <span class="badge badge-danger" :class="{ 'disabled': isReadOnly }">Inactive</span>
                  </span>
                  <span data-toggle="tooltip" title="Active" v-else>
                    <span class="badge badge-success" :class="{ 'disabled': isReadOnly }">Active</span>
                  </span>
                </span>
              </template>
                <template slot="invoice_status" slot-scope="row">
                 {{ formatStatus(row.item) }}
                    </template>
              <template slot="createddate" slot-scope="row">
                <div>
                    {{ row.item.createddate | ConvertTime12hour() }}
                </div>
            </template>
              
              <template slot="actions" slot-scope="row">
                <!-- <b-button
                  v-if="userType == 1 && isReadOnly==false"
                  size="sm"
                  data-toggle="tooltip"
                  title="Edit Vehicle Admin"
                  @click="editvehicleCityWH(row.item)"
                >
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </b-button> -->

                <!-- Button for Editing Delivery Agent Info -->
    <!-- <b-button
                  size="sm"
                  @click="openAddloadModal(row.item)"
                  data-toggle="tooltip"
                  title="Update Vehicle Details"
                >
                  Edit
                </b-button> -->
                 <b-button :disabled="isReadOnly"
                  size="sm"
                  @click="editinfoModal(row.item)"
                  data-toggle="tooltip"
                  title="Update Vehicle Details"
                >
                  Edit
                </b-button> 
               
                 
                <b-button :disabled="isReadOnly" v-if="HideAnyAction!='Yes'" 
                  size="sm"
                  title="Change Password"
                  @click="changePassword(row.item)"
                >
                  <i class="fa fa-key"></i>
                </b-button>&nbsp;

                <b-button  size="sm" :disabled="isReadOnly"
                  :title="row.item.is_available=='yes'?' Available Vehicle' : 'Not Available Vehicle'"
                  @click="changevehiclestatus(row.item)" v-if="HideAnyAction!='Yes'">
                  <i :class="row.item.is_available=='yes' ? 'fa fa-check' : 'fa fa-times'" aria-hidden="true"></i>
                  
                </b-button>
                  <b-button size="sm" @click="updateModal(row.item.vehicle_no)" title="Freight Edit" variant="success" class="custom-open-modal" >
                              <i class="fa fa-edit" aria-hidden="true"></i> Freight
                            </b-button>
                  <b-button variant="primary"  class="custom-submit" size="sm" @click="transporterMasterLog(row.item.transporter_id,row.item.vehicle_id)">Log</b-button>

                <!-- <i class="fa fa-times" aria-hidden="true"></i> -->
                <!-- end -->
              </template>
            </b-table>
          </b-col>

        </b-card>
        <div>
                <!-- Pagination -->
                <b-pagination
                  v-if="totalCount > perPage"
                  v-model="currentPage"
                  :total-rows="totalCount"
                  :per-page="perPage"
                  @change="displaydata"
                ></b-pagination>
              </div>
      </b-col>
    </b-row>

    <!-- Confirmation Box -->
    <b-modal 
    title="Confirmation Box" v-model="toggleInfo" size="md"  @ok="toggleInfo =false"
    >
      <template slot="modal-header" slot-scope="{ close }">
        <h5>Confirmation Box</h5>
      </template>
      <template slot="default" slot-scope="{ hide }">
        <form v-on:submit.prevent="activateInActivateDeliveryAgent(value)">
          <div class="modal-background"></div>
          <div class="modal-card">
            <section class="modal-card-body">
              <input
                type="hidden"
                v-model="customer.isactive"
                name="isactive"
                id="modalIsActiveChk"
              />
              <span>Are you sure you want to change the status?</span>
            </section>
            <footer>
              <b-button variant="primary" size="sm" type="submit" v-if="HideAnyAction!='Yes'">Ok</b-button>
            </footer>
          </div>
        </form>
      </template>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="danger" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>

    <!-- Update Vehicle Details -->
    <b-modal class=""
      size="xl"
      v-model="editAgentMaster"    
      @ok="editAgentMaster = false"    
      hide-footer
      @hide="editcancel"
    >
    <!-- @ok="editAgentMaster = false" -->
    <!-- title="Update Vehicle Details" -->
    <!-- sangam -->
    <template v-slot:modal-title style="width:100%">
      <!-- <h5 class="modal-title"> -->
      <div class="modal-header-right d-flex w-100">
        <div class="modal-header-custom w-100 d-flex justify-content-between">
          <h6 class="header-main-title" style="margin-bottom: 0.6rem;">Update Vehicle Details</h6>
          <div class="toggle-wrapper">
            <span class="toggle-label">Change to Adhoc Vehicle</span>
            <button
              :class="{'toggle-circle': true, 'toggle-active': isActive, 'toggle-inactive': !isActive}"
              @click="toggle"
            >
              <div class="toggle-handle"></div>
            </button>
          </div>
        </div>
      </div>
    <!-- </h5> -->
    </template>
    
      <template slot="default" slot-scope="{ hide }">
        <b-row>
          <b-col>
            <!-- regular start -->
              <div class="p-4" v-if="isActive">
               
                <b-form
                  @submit.prevent="validateForm6('form-5')"
                  data-vv-scope="form-5"
                >
                <!-- <h6 class="mt-4 text-center"><b>Update Admin</b></h6>
                <br />
                <b-row>
                    <b-col sm="6" v-if="userType==1">
                    <b-row>
                        <b-col sm="5" class="pr-0">
                        <label><b>Select Admin</b></label>&nbsp;<span style="color: red;">*</span>
                        </b-col>
                        <b-col sm="7" class="pl-0">
                        <div id="container">
                            <b-form-group>
                            <ejs-multiselect
                            id="multi_select"
                            placeholder="Select Admin"
                            v-model="valueAdmin"
                            @change="selectAdmin"
                            :dataSource="optionsAdmin"
                            :fields="fieldAdmin"
                            ></ejs-multiselect>
                            </b-form-group>
                        </div>
                        </b-col>
                    </b-row>
                    </b-col> 
                    <b-col sm="6">
                    <b-row>
                        <b-col sm="5" class="pr-0">
                        <label><b>Select City</b></label>&nbsp;<span style="color: red;">*</span>
                        </b-col>
                        <b-col sm="7" class="pl-0">
                        <div id="container">
                            <b-form-group>
                            <ejs-multiselect
                                id="multi_select"
                                placeholder="Select City"
                                v-model="valueWHAdmin"
                                @change="selectWHAdmin"
                                :dataSource="warehouseAdmin"
                                :fields="fieldwhAdmin"
                            ></ejs-multiselect>
                            </b-form-group>
                        </div>
                        </b-col>
                    </b-row>
                    </b-col>
                </b-row>
                
                <br /> 
                <hr />-->
                <h6 class="mt-4 text-center"><b>Update Driver Info</b></h6>
                    <br />
                    <b-row>
                      <b-col sm="4" v-if="userType == 1">
                        <b-form-group>
                        <b-row>
                          <b-col sm="4" class="pr-0 d-flex">
                            <label for="hub_name"><b>Select Hub</b></label>&nbsp;<span style="color: red;">*</span>
                          </b-col>
                          <b-col sm="8" class="pl-0">
                            <v-select v-model="adminHub" :options="optionHubid" placeholder="-- Select Hub --" name="hub_name" v-validate="'required|'"
                              :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-5.hub_name'),
                              }"></v-select>
                          <b-input-group class="mb-3">
                              <span
                                  style="width:240px"
                                  v-show="errors.has('form-5.hub_name')"
                                  class="help text-danger"
                                  >{{errors.first("form-5.hub_name")}}</span
                              >
                          </b-input-group>
                          </b-col>
                        </b-row>
                      </b-form-group>
                      </b-col>

                        <b-col sm="4">
                        <b-row>
                            <b-col sm="4" class="pr-0 d-flex">
                            <label><b>First Name</b></label>&nbsp;<span style="color: red;">*</span>
                            </b-col>
                            <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-form-input
                                type="text"
                                name="first name"
                                v-model="customer.driverfirstname"
                                v-validate="'required|alpha|min:3|max:30'"
                                :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-7.first name'),
                                }"
                                placeholder="Enter First Name"
                                >
                                </b-form-input>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('first name')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-7.first name')"
                                    class="help text-danger"
                                    >{{ errors.first("form-7.first name") }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        </b-col>

                        <b-col sm="4">
                        <b-row>
                            <b-col sm="4" class="pr-0 d-flex">
                            <label><b>Last Name</b></label>&nbsp;<span style="color: red;">*</span>
                            </b-col>
                            <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    name="last name"
                                    v-model="customer.driverlastname"
                                    v-validate="'required|alpha|min:3|max:30'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-7.last name'),
                                    }"
                                    placeholder="Enter Last Name"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('last name')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-7.last name')"
                                    class="help text-danger"
                                    >{{ errors.first("form-7.last name") }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        </b-col>

                        <b-col sm="4">
                        <b-row>
                            <b-col sm="4" class="pr-0 d-flex">
                            <label><b>Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                            </b-col>
                            <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    id="addmobilenumber"
                                    name="mobile number"
                                    maxlength="10"
                                    v-model="customer.drivermobilenumber"
                                    v-validate="'required|digits:10'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-7.mobile number'),
                                    }"
                                    placeholder="Enter Mobile Number"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('mobile number')"
                                    ></i>
                                </span>
                                <code
                                    v-show="errors.has('form-7.mobile number')"
                                    id="addmblnbrmsg"
                                    class="help text-danger"
                                    >{{ errors.first("form-7.mobile number") }}
                                </code>
                                </b-input-group>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        </b-col>

                        <b-col sm="4">
                        <b-row>
                            <b-col sm="4" class="pr-0 pl-0 d-flex">
                            <label><b>Vehicle Number</b></label>&nbsp;<span style="color: red;">*</span>
                            </b-col>
                            <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.editvehicleno"
                                    name="vehicleno"
                                    id="vehicleno"
                                    disabled
                                    placeholder="Enter Vehicle Number"
                                >
                                </b-form-input>
                                </b-input-group>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        </b-col>

                        <b-col sm="4">
                        <b-row>
                            <b-col sm="4" class="pr-0 pl-0 d-flex">
                            <label><b>Fuel Type</b></label>&nbsp;<span style="color: red;">*</span>
                            </b-col>
                            <b-col sm="8" class="pl-0">
                                <b-form-group>
                                <!-- <v-select v-model="customer.fueltype" name="fueltype" :options="fuelTypeOptions" placeholder="-- Select Fuel Type --" v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-5.fueltype'),
                                    }"></v-select> -->
                                    <b-form-select v-model="customer.fueltype" name="fueltype" :options="fuelTypeOptions" placeholder="-- Select Fuel Type --" v-validate="'required'"
                                    :class="{
                                      input: true,
                                      'is-invalid': errors.has('form-7.fueltype'),
                                    }"></b-form-select>
                                <b-input-group class="mb-3">
                                    <span
                                    style="width:240px"
                                    v-show="errors.has('form-7.fueltype')"
                                    class="help text-danger"
                                    >{{
                                    errors.first("form-7.fueltype")
                                    }}</span>
                                </b-input-group>                               
                                </b-form-group>
                            </b-col>
                        </b-row>
                        </b-col>

                        <b-col sm="4">
                        <b-row>
                            <b-col sm="4" class="pr-0 pl-0 d-flex">
                            <label><b>Driving License</b></label>&nbsp;<span style="color: red;">*</span>
                            </b-col>
                            <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.driving_license"
                                    name="drivinglicense"
                                    placeholder="Enter Driving License"
                                    v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has(
                                        'form-7.drivinglicense'
                                    ),
                                    }"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('drivinglicense')"
                                    ></i>
                                </span>
                                <code
                                    v-show="errors.has('form-7.drivinglicense')"
                                    id="addmblnbrmsg"
                                    class="help text-danger"
                                    >{{ errors.first("form-7.drivinglicense") }}
                                </code>
                                </b-input-group>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        </b-col>

                        <b-col sm="4">
                        <b-row>
                            <b-col sm="4" class="pr-0 pl-0 d-flex">
                            <label><b>Registration No</b></label>&nbsp;<span style="color: red;">*</span>
                            </b-col>
                            <b-col sm="8" class="pl-0">
                            <b-form-group>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.registration_no"
                                    name="registration_no"
                                    v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has(
                                        'form-7.registration_no'
                                    ),
                                    }"
                                    placeholder="Enter Registration certificate No"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span
                                    v-show="errors.has('form-7.registration_no')"
                                    class="help text-danger"
                                    >{{ errors.first("form-7.registration_no") }}
                                </span>
                                </b-input-group>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        </b-col>
                        <b-col sm="4">
                        <b-row>
                            <b-col sm="3" class="pr-0 d-flex">
                            <label><b>Status</b></label>&nbsp;<span style="color: red;">*</span>
                            </b-col>
                            <b-col sm="9" class="pl-0">
                            <b-form-group>
                                <b-form-select
                                v-model="customer.isactive"
                                name="status"
                                v-validate="'required|'"
                                :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-7.status'),
                                }"
                                >
                                <option :value="selectstatus">--Select--</option>
                                <option value="1">Active</option>
                                <option value="0">InActive</option>
                                </b-form-select>

                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-7.status')"
                                    >{{ errors.first("form-7.status") }}</i
                                    >
                                </span>
                                </b-input-group>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        </b-col>
                    </b-row>
                    <hr />
                    <br />
                    <h6 style="text-align:center">
                        <b>Vehicle Info</b>
                    </h6>
                    <br />
                    <b-col sm="7">
                      <b-row>
                        <b-col sm="5" class="pr-0 d-flex">
                          <label><b>Vehicle Dimensions Weight (in feet)</b></label>&nbsp;<span style="color: red;">*</span>
                        </b-col>
                        <b-col sm="6" class="pl-0">
                          <b-form-group>
                            <b-form-input
                              class="input"
                              type="text"
                              v-model="customer.vehicledimensionsweight"
                              name="vehicledimensionsweight"
                              v-validate="'required|decimal:3'"
                              :class="{
                                input: true,
                                'is-invalid': errors.has('form-5.vehicledimensionsweight'),
                              }"
                              placeholder="Enter Vehicle Weight Capacity"
                            >
                            </b-form-input>
                            <span
                              style="width:100px"
                              v-show="errors.has('form-5.vehicledimensionsweight')"
                              class="help text-danger"
                              >{{ errors.first("form-5.vehicledimensionsweight") }}</span
                            >
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <hr />
                    <br />
                    <h6 style="text-align:center">
                        <b>Update Transporter Info</b>
                    </h6>
                    <br />
                    <b-row>
                    <b-col sm="4">
                      <b-row>
                        <b-col sm="5" class="pr-0 d-flex">
                          <label><b>Company Name</b></label>&nbsp;<span style="color: red;">*</span>
                        </b-col>
                        <b-col sm="7" class="pl-0">
                          <b-form-group>
                            <v-select v-model="transporterCompanyName" :options="optionmailid" @input="updateTextbox" placeholder="-- Select Company --" :class="{
                                    input: true,
                                    'is-danger': errors.has('form-5.companyname'),
                                  }"></v-select>
                            <span
                                  v-show="errors.has('form-5.companyname')"
                                  class="help text-danger"
                                  >{{ errors.first("form-5.companyname") }}</span
                                >
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group label="Transporter Name" :label-cols="4">
                        <b-form-input
                          class="input"
                          type="text"
                          v-model="customer.driver_contracter_name"
                          name="driver_contracter_name"
                          v-validate="'required|alpha_spaces'"
                          placeholder="Enter Driver Transporter Name"
                          disabled>
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group label="Mobile No" :label-cols="4">
                        <b-form-input
                          class="input"
                          type="text"
                          id="contractormobilenumber"
                          name="mobilenumber"
                          maxlength="10"
                          v-model="customer.contractormobilenumber"
                          placeholder="Enter Mobile Number" disabled>
                        </b-form-input>
                        <!-- v-validate="'required|digits:10'"
                          :class="{
                            input: true,
                            'text-danger': errors.has('form-5.mobilenumber'),
                          }" -->
                        <!-- <span
                          style="width:100px"
                          v-show="errors.has('form-5.mobilenumber')"
                          class="help text-danger"
                          >{{ errors.first("form-5.mobilenumber") }}</span
                        > -->
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group label="Email ID" :label-cols="4" disabled>
                        <b-form-input
                          class="input"
                          type="text"
                          v-model="customer.contracter_emailid"
                          name="contracter_emailid"
                          v-validate="'required|email'"
                          placeholder="Enter Transporter Email ID" disabled
                        >
                        </b-form-input>
                        <!-- <span
                          style="width:100px"
                          v-show="errors.has('form-5.contracter_emailid')"
                          class="help text-danger"
                          >{{ errors.first("form-5.contracter_emailid") }}</span
                        > -->
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group label="Tin Number / GST Number" :label-cols="4">
                        <b-form-input
                        name="GST Number" type="text"
                        v-model="customer.transporter_gstnumber" @input="checkGSTlength(customer.transporter_gstnumber)" 
                        placeholder="Enter Tin Number / GST Number"
                        :class="{ input: true, 'is-invalid': errors_GST,
                        }">
                        </b-form-input>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning" v-if="errors_GST">
                                <i
                                class="fa fa-warning help text-danger"
                                >{{ errors_showGST.transporter_gstnumber }}</i
                                >
                            </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <button type="button" class="btn btn-outline-success btn-md" v-if="showverifybutton" @click="verifyGSTNo()">Verify</button>&nbsp;
                      <button type="button" class="btn btn-outline-danger btn-md" v-if="removeGST" @click="removevalue()">X</button>
                    </b-col>
                  </b-row>
                    <hr />
                    <br />
                    <hr />
            <br />
            <h6 v-if="vehicle_historylog.length > 0" style="text-align:center"><b>Vehicle Details Change History</b></h6>

            <div class="col-md-12 px-0 mt-2 ml-0 d-block"  v-if="vehicle_historylog.length > 0">
            <table class="table table-bordered table-hover">
             <thead>
               <tr>
                   <th>Vehicle Updated From</th>
                   <th>Vehicle Updated To</th>
                   <th>Vehicle Updated On</th>
                   <th>Vehicle Updated By</th>
                   <th>Comment</th>


               </tr>
           </thead> 
           <tbody v-if="vehicle_historylog.length > 0">
             <tr v-for="(data,key) in vehicle_historylog">
                   <td>{{data.updated_from == 'adhoc' ? data.updated_from : 'Regular' }}</td>
                   <td>{{data.updated_to == 'adhoc' ? data.updated_to : 'Regular'}}</td>
                   <td>{{ data.vehicle_updated_on | ConvertTime12hour() }}</td>
                   <td>{{data.vehicle_updated_by}}</td>
                    <td>{{ data.changecomment }}</td>
               </tr>
           </tbody>
           </table>
         </div>
            
            <hr v-if="vehicle_historylog.length > 0" />
                  
                    <br />
                  <div slot="footer" class="text-right">
                    <div id="overlayModal">
                      <div class="loaderModal"></div>
                    </div>
                    <b-button type="submit" size="sm" class="mr-4" variant="primary" id="submitButton" v-if="HideAnyAction!='Yes'">
                      Update</b-button
                    >
                    <b-button size="sm" variant="danger" @click="editcancel()"
                      >cancel</b-button
                    >
                  </div>
              </b-form>
              </div>
              <!-- Rehular END -->
              <!-- adhoc start -->
              <div class="p-4" v-if="!isActive">
                <!-- HIiiiiii -->
                <!-- <h6>Change to Adhoc Vehicle</h6>
        <button
          :class="{'toggle-circle': true, 'toggle-active': isActive, 'toggle-inactive': !isActive}"
          @click="toggle" 
        >
          <h6 style="text-align:center"><b>Update Vehicle Info</b></h6>
          <br />
          <b-row>
             <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0">
                  <label><b>Vehicle Name</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      type="text"
                      name="vehicle_name"
                      v-model="customer.vehiclename"
                      v-validate="'required|min:3|max:30'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehicle_name'),
                      }"
                      placeholder="Enter Vehicle Name"
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.vehicle_name')"
                      class="help text-danger"
                      >{{ errors.first("form-5.vehicle_name") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col> -->
            <b-form
              @submit.prevent="validateForm5('form-5')"
              data-vv-scope="form-5"
            >
            
          
              <h6 style="text-align:center"><b>Update Vehicle Info</b></h6>
              <br />
            <b-row>
              <b-col sm="4" v-if="userType == 1">
                <b-form-group>
                <b-row>
                  <b-col sm="4" class="pr-0 d-flex">
                    <label for="hub_name"><b>Select Hub</b></label>&nbsp;<span style="color: red;">*</span>
                  </b-col>
                  <b-col sm="8" class="pl-0">
                    <v-select v-model="adminHub" :options="optionHubid" placeholder="-- Select Hub --" name="hub_name" v-validate="'required|'"
                      :class="{
                          input: true,
                          'is-invalid': errors.has('form-5.hub_name'),
                      }"></v-select>
                  <b-input-group class="mb-3">
                      <span
                          style="width:240px"
                          v-show="errors.has('form-5.hub_name')"
                          class="help text-danger"
                          >{{errors.first("form-5.hub_name")}}</span
                      >
                  </b-input-group>
                  </b-col>
                </b-row>
              </b-form-group>
              </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Vehicle Name</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                      <!-- <v-select v-model="customer.vehiclename" name="vehicle_name" :options="vehicleNameOptions" @input="addVehicleName" placeholder="-- Select Vehicle Name --" v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehicle_name'),
                      }"></v-select> -->

                        <b-form-select v-model="customer.vehiclename" name="vehicle_name" :options="vehicleNameOptions" @input="addVehicleName" placeholder="-- Select Vehicle Name --" v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehicle_name'),
                      }"></b-form-select>

                        <b-input-group class="mb-3">
                          <span
                            style="width:240px"
                            v-show="errors.has('form-5.vehicle_name')"
                            class="help text-danger"
                          >{{
                            errors.first("form-5.vehicle_name")
                          }}</span>
                        </b-input-group>                               
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col sm="4" v-if="vehiclenametext">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Vehicle Name</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                      <b-form-input
                        type="text"
                        name="vehicle name"
                        v-model="customer.vehiclenametext"
                        v-validate="'required|min:3|max:30'"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-5.vehicle name'),
                        }"
                        placeholder="Enter Vehicle Name"
                      >
                      </b-form-input>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('vehicle name')"
                          ></i>
                        </span>
                        <span
                          style="width:240px"
                          v-show="errors.has('form-5.vehicle name')"
                          class="help text-danger"
                        >{{ errors.first("form-5.vehicle name") }}</span>
                      </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col sm="4">
              <b-row>
                <b-col sm="5" class="pr-0 d-flex">
                  <label><b>Vehicle Number</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="7" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      v-model="customer.editvehicleno"
                      name="vehicleno" disabled
                      placeholder="Enter Vehicle Number"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col sm="4">
              <b-row>
                <b-col sm="5" class="pr-0 d-flex">
                  <label><b>Registration No</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="7" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      type="text"
                      name="registration_no"
                      v-model="customer.registration_no"
                      v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.registration_no'),
                      }"
                      placeholder="Enter Registration Certificate No"
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.registration_no')"
                      class="help text-danger"
                      >{{ errors.first("form-5.registration_no") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <!-- <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0">
                  <label><b>Vehicle Type</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-select
                      v-model="customer.vehicletype"
                      name="vehicletype"
                      v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehicletype'),
                      }"
                    >
                      <option value="">--Select--</option>
                      <option value="inter">Inter City</option>
                      <option value="intra">Intra City</option>
                    </b-form-select>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.vehicletype')"
                      class="help text-danger"
                      >{{ errors.first("form-5.vehicletype") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col> -->

            <b-col sm="4">
              <b-row>
                <b-col sm="5" class="pr-0 d-flex">
                  <label><b>Movement Type</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="7" class="pl-0">
                  <b-form-group>
                    <b-form-select
                      v-model="customer.vehicletype"
                      name="movementtype"
                      v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.movementtype'),
                      }"
                    >
                      <option value="">--Select--</option>
                      <option value="inter">Inter City</option>
                      <option value="intra">Intra City</option>
                    </b-form-select>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.movementtype')"
                      class="help text-danger"
                      >{{ errors.first("form-5.movementtype") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <!-- <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0">
                  <label><b>Make Type</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      v-model="customer.vehiclemake"
                      name="vehiclemake"
                      v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehiclemake'),
                      }"
                      placeholder="Enter Vehicle Make"
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.vehiclemake')"
                      class="help text-danger"
                      >{{ errors.first("form-5.vehiclemake") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col> -->
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Vehicle Type</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                   <!--  <v-select v-model="customer.vehicletypesize" name="vehicletypesize" :options="vehicleTypeSizeOptions" @input="addVehicleTypeSize" placeholder="-- Select Vehicle Type --" v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehicletypesize'),
                      }"></v-select> -->

                      <b-form-select v-model="customer.vehicletypesize" name="vehicletypesize" :options="vehicleTypeSizeOptions" @input="addVehicleTypeSize" placeholder="-- Select Vehicle Type --" v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehicletypesize'),
                      }"></b-form-select>

                      <b-input-group class="mb-3">
                        <span
                          style="width:240px"
                          v-show="errors.has('form-5.vehicletypesize')"
                          class="help text-danger"
                        >{{
                          errors.first("form-5.vehicletypesize")
                        }}</span>
                      </b-input-group>                               
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col sm="4" v-if="vehicletypesizetext">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Vehicle Type</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                      <b-form-input
                        type="text"
                        name="vehicle_type_size"
                        v-model="customer.vehicletypesizetext"
                        v-validate="'required|numeric'"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-5.vehicle_type_size'),
                        }"
                        placeholder="Enter Vehicle Type"
                      >
                      </b-form-input>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('vehicle_type_size')"
                          ></i>
                        </span>
                        <span
                          style="width:240px"
                          v-show="errors.has('form-5.vehicle_type_size')"
                          class="help text-danger"
                        >{{ errors.first("form-5.vehicle_type_size") }}</span>
                      </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Vol Weight</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      v-model="customer.vehicleweightcarrying"
                      name="vehicleweightcarrying"
                      v-validate="'required|decimal:3'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehicleweightcarrying'),
                      }"
                      placeholder="Enter Vehicle Weight Capacity"
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.vehicleweightcarrying')"
                      class="help text-danger"
                      >{{ errors.first("form-5.vehicleweightcarrying") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Phy Weight</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      v-model="customer.vehiclephysicalweight"
                      name="vehiclephysicalweight"
                      v-validate="'required|decimal:3'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehiclephysicalweight'),
                      }"
                      placeholder="Enter Vehicle Weight Capacity"
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.vehiclephysicalweight')"
                      class="help text-danger"
                      >{{ errors.first("form-5.vehiclephysicalweight") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <!-- <b-col sm="4">
              <b-row>
                <b-col sm="5" class="pr-0 d-flex">
                  <label><b>Dimensions Weight</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="7" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      v-model="customer.vehicledimensionsweight"
                      name="vehicledimensionsweight"
                      v-validate="'required|decimal:3'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.vehicledimensionsweight'),
                      }"
                      placeholder="Enter Vehicle Weight Capacity"
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.vehicledimensionsweight')"
                      class="help text-danger"
                      >{{ errors.first("form-5.vehicledimensionsweight") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col> -->

            <b-col sm="4">
              <b-row>
                <b-col sm="5" class="pr-0 d-flex">
                  <label><b>Fuel Type</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="7" class="pl-0">
                  <b-form-group>
                          <b-form-select v-model="customer.fueltype" name="fueltype" :options="fuelTypeOptions" placeholder="-- Select Fuel Type --" v-validate="'required'"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-5.fueltype'),
                        }"></b-form-select>


                      <!-- <v-select v-model="customer.fueltype" name="fueltype" :options="fuelTypeOptions" placeholder="-- Select Fuel Type --" v-validate="'required'"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-5.fueltype'),
                        }"></v-select> -->
                      <b-input-group class="mb-3">
                        <span
                          style="width:240px"
                          v-show="errors.has('form-5.fueltype')"
                          class="help text-danger"
                        >{{
                          errors.first("form-5.fueltype")
                        }}</span>
                      </b-input-group>                               
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                  <b-col sm="5" class="pr-0">
                    <div class="d-flex">  
                      <label><b>Upload PUC</b></label>&nbsp;<span style="color: red;">*</span></div>
                  </b-col>
                  <b-col sm="7" class="pl-0">
                      <b-form-group>
                          <div class="d-flex align-items-center">
                              <b-form-file type="file" v-model="customer.pucnumberfile" @change="pucFileUplod1($event)" id="puc_file" placeholder="Upload PUC" class="custom-border" name="puc_file" v-validate="'required|'" :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.puc_file'),
                    }">
                              </b-form-file>
                              <b-button variant="primary" class="ms-3" @click="downloadFile(customer.puc_url)" v-b-tooltip.hover="'Download File'">
                                  <i class="fas fa-download"></i>
                              </b-button>
                          </div>
                          <b-input-group class="mb-3">
                              <span style="width:240px" v-show="errors.has('form-5.puc_file')" class="help text-danger">{{
                    errors.first("form-5.puc_file")
                    }}</span
                >
                      </b-input-group>
                  </b-form-group>
                 </b-col> 
              </b-row>
              </b-col>
              <b-col sm="4">
                <b-row>
                  <b-col sm="5" class="pr-0">
                    <div class="d-flex">  
                    <label><b>Upload RC</b></label>&nbsp;<span style="color: red;">*</span></div>
                              </b-col>
                              <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <div class="d-flex align-items-center">
                                          <b-form-file placeholder="Upload RC" class="custom-border" type="file" v-model="customer.registration_url" @change="registrationFileUplod($event)" id="registration_file" name="registration_file" v-validate="'required'" :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-5.registration_file'),
                                }">
                                          </b-form-file>
                                          <b-button variant="primary" class="ms-3" @click="downloadFile(customer.registration_url)" v-b-tooltip.hover="'Download File'"> <i class="fas fa-download"></i>
                                          </b-button>
                                      </div>
                                      <b-input-group class="mb-3">
                                          <span style="width:240px" v-show="errors.has('form-5.registration_file')" class="help text-danger">{{
                                errors.first("form-5.registration_file")
                                }}</span
                            >
                            </b-input-group>
                  </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="4">
                <b-row>
                  <b-col sm="5" class="pr-0">
                    <div class="d-flex">  
                    <label><b>Upload Permit</b></label>&nbsp;<span style="color: red;">*</span></div>
                              </b-col>
                              <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <div class="d-flex align-items-center">
                                          <b-form-file placeholder="Upload Permit" class="custom-border" type="file" v-model="customer.permit_url" @change="permitFileUplod($event)" id="permit_file" name="permit_file" v-validate="'required'" :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-5.permit_file'),
                                }">
                                          </b-form-file>
                                          <b-button variant="primary" class="ms-3" @click="downloadFile(customer.permit_url)" v-b-tooltip.hover="'Download File'"> <i class="fas fa-download"></i>
                                          </b-button>
                                      </div>
                                      <b-input-group class="mb-3">
                                          <span style="width:240px" v-show="errors.has('form-5.permit_file')" class="help text-danger">{{
                                errors.first("form-5.permit_file")
                                }}</span
                            >
                            </b-input-group>
                  </b-form-group>
                  </b-col>
                 
                </b-row>
              </b-col>
                <b-col sm="4">
                  <b-row>
                  <b-col sm="5">
                    <div class="d-flex">  
                    <label><b>Upload Insurance</b><span style="color: red;">*</span></label></div>
                              </b-col>
                              <b-col sm="7">
                                  <b-form-group>
                                      <div class="d-flex align-items-center">
                                          <b-form-file placeholder="Upload Insurance File" class="custom-border" type="file" v-model="customer.insurance_url" @change="insuranceFileUplod($event)" v-validate="'required'" id="insurance_file" name="insurance_file" :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-5.insurance_file'),
                                }">
                                          </b-form-file>
                                          <b-button variant="primary" class="ms-3" @click="downloadFile(customer.insurance_url)" v-b-tooltip.hover="'Download File'"> <i class="fas fa-download"></i>
                                          </b-button>
                                      </div>
                                      <b-input-group class="mb-3">
                                          <span style="width:240px" v-show="errors.has('form-5.insurance_file')" class="help text-danger">{{
                                errors.first("form-5.insurance_file")
                                }}</span
                            >
                            </b-input-group>
                  </b-form-group>
                  </b-col>
                </b-row>
                </b-col>



                <b-col sm="4">
                  <b-row>
                    <b-col sm="5" class="pr-0">
                      <div class="d-flex">  
                      <label><b>Fixed KM's</b></label>&nbsp;<span style="color: red;">*</span></div>
                              </b-col>
                              <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input class="input" @change="calculateFreightCostEdit" type="text" v-model="customer.fixed_kms" name="fixed_kms" v-validate="'required'" :class="{
                            input: true,
                            'is-invalid': errors.has('form-5.fixed_kms'),
                          }" placeholder="Enter Fixed Kms">
                                      </b-form-input>
                                      <span style="width:100px" v-show="errors.has('form-5.fixed_kms')" class="help text-danger">{{ errors.first("form-5.fixed_kms") }}</span
                        >
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="5" class="pr-0">
                      <div class="d-flex">  
                      <label><b>Fixed Freight Rate/KM</b></label>&nbsp;<span style="color: red;">*</span></div>
                              </b-col>
                              <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input  @change="calculateFreightCostEdit" class="input" type="text" v-model="customer.fixed_freightrate" name="fixed_freightrate" v-validate="'required'" :class="{
                            input: true,
                            'is-invalid': errors.has('form-5.fixed_freightrate'),
                          }" placeholder="Enter Fixed Freight Rate/KM">
                                      </b-form-input>
                                      <span style="width:100px" v-show="errors.has('form-5.fixed_freightrate')" class="help text-danger">{{ errors.first("form-5.fixed_freightrate") }}</span
                        >
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>

                 <b-col sm="4">
                  <b-row>
                      <b-col sm="5" class="pr-0">
                        <div class="d-flex">  
                        <label><b>Fixed Freight Cost</b></label></div>
                      </b-col>
                      <b-col sm="7" class="pl-0">
                        <b-form-group>
                            <b-form-input class="input" type="text" disabled v-model="fixedFreightCostEdit"  placeholder="Enter Fixed Freight  Cost">
                          </b-form-input>                                    
                        </b-form-group>
                      </b-col>
                  </b-row>
                </b-col>

                <b-col sm="4">
                  <b-row>
                      <b-col sm="5" class="pr-0">
                        <div class="d-flex">  
                        <label><b>Fixed Freight Per Day</b></label></div>
                      </b-col>
                      <b-col sm="7" class="pl-0">
                        <b-form-group>
                            <b-form-input class="input" type="text" disabled v-model="fixedFreightPerDayEdit"  placeholder="Fixed Freight Per Day">
                          </b-form-input>                                    
                        </b-form-group>
                      </b-col>
                  </b-row>
                </b-col>

                <b-col sm="4">
                  <b-row>
                    <b-col sm="5" class="pr-0">
                      <div class="d-flex">  
                      <label><b>Extra KM Rate</b></label>&nbsp;<span style="color: red;">*</span></div>
                              </b-col>
                              <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input class="input" type="text" v-model="customer.extra_kmrate" name="extra_kmrate" v-validate="'required'" :class="{
                            input: true,
                            'is-invalid': errors.has('form-5.extra_kmrate'),
                          }" placeholder="Enter Extra KM rate">
                                      </b-form-input>
                                      <span style="width:100px" v-show="errors.has('form-5.extra_kmrate')" class="help text-danger">{{ errors.first("form-5.extra_kmrate") }}</span
                        >
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>

                
                <b-col sm="4">
                  <b-row>
                    <b-col sm="5" class="pr-0">
                      <div class="d-flex">  
                      <label><b>Fixed Labour Cost</b></label>&nbsp;<span style="color: red;">*</span></div>
                              </b-col>
                              <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input class="input" @change="calculateFreightCostEdit" type="text" v-model="customer.labour_charges" name="labour_charges" v-validate="'required'" :class="{
                            input: true,
                            'is-invalid': errors.has('form-5.labour_charges'),
                          }" placeholder="Enter Labour Cost">
                                      </b-form-input>
                                      <span style="width:100px" v-show="errors.has('form-5.labour_charges')" class="help text-danger">{{ errors.first("form-5.labour_charges") }}</span
                        >
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col sm="4">
                  <b-row>
                      <b-col sm="5" class="pr-0">
                        <div class="d-flex">  
                        <label><b>Fixed Labour Per Day</b></label></div>
                      </b-col>
                      <b-col sm="7" class="pl-0">
                        <b-form-group>
                            <b-form-input class="input" type="text" disabled v-model="fixedLabourPerDayEdit"  placeholder="Fixed Labour Per Day">
                          </b-form-input>                                    
                        </b-form-group>
                      </b-col>
                  </b-row>
                </b-col>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="5" class="pr-0">
                      <div class="d-flex">  
                      <label><b>Total Working Days</b></label>&nbsp;<span style="color: red;">*</span></div>
                              </b-col>
                              <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input @change="calculateFreightCostEdit" class="input" type="text" v-model="customer.workingdays" name="workingdays" v-validate="'required'" :class="{
                            input: true,
                            'is-invalid': errors.has('form-5.workingdays'),
                          }" placeholder="Enter Total Days" disabled>
                                      </b-form-input>
                                      <span style="width:100px" v-show="errors.has('form-5.workingdays')" class="help text-danger">{{ errors.first("form-5.workingdays") }}</span
                        >
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>


            <b-col sm="6">
              <b-row>
                <b-col sm="3" class="pr-0 d-flex">
                  <label><b>Payment Type</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                 <b-col  sm="9" class="pl-0">
                                  <b-form-group> 
                                    <b-form-radio-group 
                                          v-model="customer.paymenttype" 
                                          v-validate="'required'"
                                          :options="[
                                              { text: 'Daily', value: 'tripend' }, 
                                              { text: 'Weekly', value: 'weekly' },
                                              { text: 'Monthly', value: 'monthly' }
                                          ]"
                                          name="payment_type"
                                          id="payment_type"
                                          :class="{
                                              input: true,
                                              'is-invalid': errors.has('form-5.payment_type'),
                                          }"
                                      >
                                      </b-form-radio-group>
                                      <b-input-group class="mb-3">
                                      <span
                                          style="width:240px"
                                          v-show="errors.has('form-5.payment_type')"
                                          class="help text-danger"
                                          >{{
                                          errors.first("form-5.payment_type")
                                          }}</span
                                      >
                                      </b-input-group>
                                  </b-form-group>
                                </b-col>
              </b-row>
            </b-col>

          </b-row>
          <hr />
          <br />
          <h6 style="text-align:center"><b>Update Driver Info</b></h6>
          <br />
          <b-row>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>First Name</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      id="driverfirstname"
                      name="driverfirstname"
                      v-model="customer.driverfirstname"
                      v-validate="'required|alpha|min:3|max:30'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.driverfirstname'),
                      }"
                      placeholder="Enter First Name"
                    >
                    </b-form-input>
    
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.driverfirstname')"
                      class="help text-danger"
                      >{{ errors.first("form-5.driverfirstname") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Last Name</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      id="driverlastname"
                      name="driverlastname"
                      v-model="customer.driverlastname"
                      v-validate="'required|alpha|min:3|max:30'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.driverlastname'),
                      }"
                      placeholder="Enter First Name"
                    >
                    </b-form-input>
    
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.driverlastname')"
                      class="help text-danger"
                      >{{ errors.first("form-5.driverlastname") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text" maxlength="10"
                      v-model="customer.mobile_no"
                      name="mobile_no"
                      v-validate="'required|digits:10'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.mobile_no'),
                      }"
                      placeholder="Enter Mobile Number "
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.mobile_no')"
                      class="help text-danger"
                      >{{ errors.first("form-5.mobile_no") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Alt Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text" maxlength="10"
                      v-model="customer.altmobile_no"
                      name="altmobile_no"
                      v-validate="'required|digits:10'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.altmobile_no'),
                      }"
                      placeholder="Enter Mobile Number "
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.altmobile_no')"
                      class="help text-danger"
                      >{{ errors.first("form-5.altmobile_no") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="5" class="pr-0 d-flex">
                  <label><b>Driving License</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="7" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      v-model="customer.driving_license"
                      name="driving_license"
                      v-validate="'required'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.driving_license'),
                      }"
                      placeholder="Enter Driving License"
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.driving_license')"
                      class="help text-danger"
                      >{{ errors.first("form-5.driving_license") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <br />
          <h6 style="text-align:center"><b>Update Helper Info</b></h6>
          <br />
          <b-row>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>First Name</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      id="helperfirstname"
                      name="helperfirstname"
                      v-model="customer.helperfirstname"
                      v-validate="'required|alpha|min:3|max:30'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.helperfirstname'),
                      }"
                      placeholder="Enter First Name"
                    >
                    </b-form-input>
    
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.helperfirstname')"
                      class="help text-danger"
                      >{{ errors.first("form-5.helperfirstname") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Last Name</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      id="helperlastname"
                      name="helperlastname"
                      v-model="customer.helperlastname"
                      v-validate="'required|alpha|min:3|max:30'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.helperlastname'),
                      }"
                      placeholder="Enter First Name"
                    >
                    </b-form-input>
    
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.helperlastname')"
                      class="help text-danger"
                      >{{ errors.first("form-5.helperlastname") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      id="addmobilenumber"
                      name="mobilenumber"
                      maxlength="10"
                      v-model="customer.helpermobilenumber"
                      v-validate="'required|digits:10'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.mobilenumber'),
                      }"
                      placeholder="Enter Mobile Number"
                    >
                    </b-form-input>
    
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.mobilenumber')"
                      class="help text-danger"
                      >{{ errors.first("form-5.mobilenumber") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="4" class="pr-0 d-flex">
                  <label><b>Alt Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="8" class="pl-0">
                  <b-form-group>
                    <b-form-input
                      class="input"
                      type="text"
                      id="addaltenatemobilenumber"
                      name="helperaltmobilenumber"
                      maxlength="10"
                      v-model="customer.helperaltmobilenumber"
                      v-validate="'required|digits:10'"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-5.helperaltmobilenumber'),
                      }"
                      placeholder="Enter Alternate Mobile Number"
                    >
                    </b-form-input>
                    <span
                      style="width:100px"
                      v-show="errors.has('form-5.helperaltmobilenumber')"
                      class="help text-danger"
                      >{{ errors.first("form-5.helperaltmobilenumber") }}</span
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <br />
          <h6 style="text-align:center"><b>Update Transporter Info</b></h6>
          <br />
          <b-row>
            <b-col sm="4">
              <b-form-group :label-cols="3"> 
                <template v-slot:label>
                  Type of Vendor <span style="color: red;">&nbsp;*</span>
                </template>
                  <b-form-radio-group 
                      id="vendor type" 
                      v-model="customer.vendortype" 
                      v-validate="'required'"
                      :options="[
                          { text: 'Aggregator', value: 'aggregator' }, 
                          { text: 'Normal', value: 'normal' }
                      ]"
                      name="vendor type"
                  >
                  </b-form-radio-group>
                  <b-input-group class="mb-3">
                    <span style="width:240px" v-show="errors.has('form-5.vendor type')" class="help text-danger">{{ errors.first("form-5.vendor type") }}</span>
                  </b-input-group>
                  
              </b-form-group>

              </b-col>
            <b-col sm="4">
              <b-row>
                <b-col sm="5" class="pr-0 d-flex">
                  <label><b>Company Name</b></label>&nbsp;<span style="color: red;">*</span>
                </b-col>
                <b-col sm="7" class="pl-0">
                  <b-form-group>
                    <v-select v-model="transporterCompanyName" :options="optionmailid" @input="updateTextbox" placeholder="-- Select Company --" :class="{
                            input: true,
                            'is-danger': errors.has('form-5.companyname'),
                          }"></v-select>
                    <span
                          v-show="errors.has('form-5.companyname')"
                          class="help text-danger"
                          >{{ errors.first("form-5.companyname") }}</span
                        >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Transporter Name" :label-cols="4">
                <b-form-input
                  class="input"
                  type="text"
                  v-model="customer.driver_contracter_name"
                  name="driver_contracter_name"
                  v-validate="'required|alpha_spaces'"
                  placeholder="Enter Driver Transporter Name"
                  disabled>
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Mobile No" :label-cols="4">
                <b-form-input
                  class="input"
                  type="text"
                  id="contractormobilenumber"
                  name="mobilenumber"
                  maxlength="10"
                  v-model="customer.contractormobilenumber"
                  placeholder="Enter Mobile Number" disabled>
                </b-form-input>
                <!-- v-validate="'required|digits:10'"
                  :class="{
                    input: true,
                    'text-danger': errors.has('form-5.mobilenumber'),
                  }" -->
                <!-- <span
                  style="width:100px"
                  v-show="errors.has('form-5.mobilenumber')"
                  class="help text-danger"
                  >{{ errors.first("form-5.mobilenumber") }}</span
                > -->
              </b-form-group>
            </b-col>

            <b-col sm="4">
              <b-form-group label="Email ID" :label-cols="4" disabled>
                <b-form-input
                  class="input"
                  type="text"
                  v-model="customer.contracter_emailid"
                  name="contracter_emailid"
                  v-validate="'required|email'"
                  placeholder="Enter Transporter Email ID" disabled
                >
                </b-form-input>
                <!-- <span
                  style="width:100px"
                  v-show="errors.has('form-5.contracter_emailid')"
                  class="help text-danger"
                  >{{ errors.first("form-5.contracter_emailid") }}</span
                > -->
              </b-form-group>
            </b-col>

            <b-col sm="4">
              <b-form-group label="Tin Number / GST Number" :label-cols="4">
                <b-form-input
                name="GST Number" type="text"
                v-model="customer.transporter_gstnumber" @input="checkGSTlength(customer.transporter_gstnumber)" 
                placeholder="Enter Tin Number / GST Number"
                :class="{ input: true, 'is-invalid': errors_GST,
                }">
                </b-form-input>
                <b-input-group class="mb-3">
                  <span class="icon has-text-warning" v-if="errors_GST">
                        <i
                        class="fa fa-warning help text-danger"
                        >{{ errors_showGST.transporter_gstnumber }}</i
                        >
                    </span>
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- <b-col sm="4">
                  <b-form-group :label-cols="4">
                    <template v-slot:label>
                      Promoter Name <span style="color: red;">*</span>
                </template>
                  <b-input-group class="mb-3">
                      <b-form-input class="input" type="text" id="promoter name" name="promoter name" v-model="customer.promotername" :class="{
                          input: true,'is-invalid': errors.has('form-5.promoter name'),}" placeholder="Enter Promoter Name"></b-form-input>
                  </b-input-group>
                  <b-input-group class="mb-3">

                      <span class="icon has-text-warning">
                      <code v-show="errors.has('form-5.promoter name')" id="addpromotererrormsg" class="help text-danger">{{ errors.first("form-5.promoter name") }}
                      </code>
                      </span>
                  </b-input-group>
                  </b-form-group>
              </b-col> -->
              <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                      PAN <span style="color: red;">&nbsp;*</span>
                </template>
                <!-- <label for="panno">PAN</label>&nbsp;<span style="color: red;">*</span> -->
                <b-input-group class="mb-3">
                    <b-form-input class="input" type="text" id="pan number" name="pan number" v-model="customer.pan" v-validate="'required|max:50'" :class="{
                        input: true,'is-invalid': errors.has('form-5.pan number'),}" placeholder="Enter PAN Number"></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('panno')"></i>
                    </span>
                    <code v-show="errors.has('form-5.pan number')" id="addpannoerrmsg" class="help text-danger">{{ errors.first("form-5.pan number") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    Aadhaar <span style="color: red;">&nbsp;*</span>
                </template>
                <!-- <label for="adhaarno">Aadhaar</label>&nbsp;<span style="color: red;">*</span> -->
                <b-input-group class="mb-3">
                    <b-form-input class="input" type="text" id="adhaar number" name="adhaar number" v-model="customer.aadhar" v-validate="'required|max:50'" :class="{
                        input: true,'is-invalid': errors.has('form-5.adhaar number'),}" placeholder="Enter Aadhaar Number"></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('adhaarno')"></i>
                    </span>
                    <code v-show="errors.has('form-5.adhaar number')" id="addpannoerrmsg" class="help text-danger">{{ errors.first("form-5.adhaar number") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    Bank Cancelled Cheque<span style="color: red;">&nbsp;*</span>
                </template>
                <!-- <label for="bankcancelledcheque">Bank Cancelled Cheque</label>&nbsp;<span style="color: red;">*</span> -->
                <div class="d-flex align-items-center">

                    <b-form-file
                        type="file"
                        v-model="customer.bankcancelledcheque"
                        placeholder="Bank Cancelled Cheque" 
                        @change="selectBankChequeFile($event)"
                        class="custom-border"
                        v-validate="'required'"
                        id="bank cancelled cheque" 
                        name="bank cancelled cheque" :class="{
                        input: true,'is-invalid': errors.has('form-5.bank cancelled cheque'),}"                                     >
                        <template v-slot:file-name >
                            {{ bankFileName }}
                        </template>
                    </b-form-file>
                      <!-- Download Button -->
                      <b-button 
                          variant="primary" 
                          class="ms-3" 
                          @click="downloadFile(customer.bankcancelledcheque)"
                          v-b-tooltip.hover="'Download File'"
                      >
                      <i class="fas fa-download"></i>
                      </b-button>
                    </div>
                <b-input-group class="mb-3">
                    <code v-show="errors.has('form-5.bank cancelled cheque')" id="addpannoerrmsg" class="help text-danger">{{ errors.first("form-5.bank cancelled cheque") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    GSTIN Certificate
                </template>
                <!-- <label for="gstincertificate">GSTIN Certificate</label>&nbsp; -->
                <div class="d-flex align-items-center">

                    <b-form-file
                        type="file"
                        v-model="customer.gstincertificate"
                        placeholder="GSTIN Certificate" 
                        @change="selectGstinCertficateFile($event)"
                        class="custom-border"
                        id="gstin certficate" name="gstin certficate" 
                          :class="{
                        input: true,'is-invalid': errors.has('form-5.gstin certficate'),}"
                        >
                        <template v-slot:file-name>
                            {{ gstinCertficateFilename }}
                        </template>
                    </b-form-file>
                    <b-button 
                          variant="primary" 
                          class="ms-3" 
                          @click="downloadFile(customer.gstincertificate)"
                          v-b-tooltip.hover="'Download File'"
                      >
                      <i class="fas fa-download"></i>
                      </b-button>
                    </div>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('gstin certficate')"></i>
                    </span>
                    <code v-show="errors.has('form-5.gstin certficate')" id="gstincertficateerrmsg" class="help text-danger">{{ errors.first("form-5.gstin certficate") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    Pincode
                </template>
                <!-- <label for="pincode">Pincode</label>&nbsp; -->
                <v-select v-model="customer.pincode" :options="pincodes" placeholder="-- Select Pincode --" @change="pincodeChange(customer.pincode)"></v-select>
                <b-input-group class="mb-3" >
                    <span
                        style="width:240px"
                        v-show="errors.has('form-5.pincode')"
                        class="help text-danger"
                        
                        >{{
                        errors.first("form-5.pincode")
                        }}</span
                    >
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    Address <span style="color: red;">&nbsp;*</span>
                </template>
                <!-- <label for="address">Address</label>&nbsp;<span style="color: red;">*</span> -->
                <b-input-group class="mb-3">
                    <b-form-input class="input"  v-validate="'required'"
                    type="text" id="address" name="address" v-model="customer.address" :class="{
                        input: true,'is-invalid': errors.has('form-5.address'),}" placeholder="Enter Address"></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('address')"></i>
                    </span>
                    <code v-show="errors.has('form-5.address')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-5.address") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4" v-if="customer.pincode">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    City
                </template>
                <!-- <label for="city">City</label>&nbsp; -->
                <b-input-group class="mb-3">
                    <b-form-input class="input" type="text" id="city" name="city" v-model="customer.city" :class="{
                        input: true,'is-invalid': errors.has('form-5.city'),}" placeholder=""></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('city')"></i>
                    </span>
                    <code v-show="errors.has('form-5.city')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-5.address") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4" v-if="customer.pincode">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    State
                </template>
                <!-- <label for="state">State</label>&nbsp; -->
                <b-input-group class="mb-3">
                    <b-form-input class="input" type="text" id="state" name="state" v-model="customer.state" :class="{
                        input: true,'is-invalid': errors.has('form-5.state'),}" placeholder=""></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('state')"></i>
                    </span>
                    <code v-show="errors.has('form-5.state')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-5.state") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    Bank name<span style="color: red;"> &nbsp;*</span>
                </template>
                <!-- <label for="bankname">Bank name</label>&nbsp;<span style="color: red;">*</span> -->
                <b-input-group class="mb-3">
                    <b-form-input class="input" v-validate="'required'"
                    type="text" id="bankname" name="bankname" v-model="customer.bankname" :class="{
                        input: true,'is-invalid': errors.has('form-5.bankname'),}" placeholder="Enter Bank name"></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('bankname')"></i>
                    </span>
                    <code v-show="errors.has('form-5.bankname')" id="banknameerrmsg" class="help text-danger">{{ errors.first("form-5.bankname") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    Bank Account Name<span style="color: red;">&nbsp;*</span>
                </template>
                <!-- <label for="bankaccountname">Bank Account Name</label>&nbsp;<span style="color: red;">*</span> -->
                <b-input-group class="mb-3">
                    <b-form-input class="input" type="text"  v-validate="'required'" id="bankaccountname" name="bankaccountname" v-model="customer.bankaccountname" :class="{
                        input: true,'is-invalid': errors.has('form-5.bankaccountname'),}" placeholder="Enter Bank Account Name"></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('bankaccountname')"></i>
                    </span>
                    <code v-show="errors.has('form-5.bankaccountname')" id="bankaccountnameerrmsg" class="help text-danger">{{ errors.first("form-5.bankaccountname") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    Branch Name<span style="color: red;">&nbsp;*</span>
                </template>
                <!-- <label for="branchname">Branch Name</label>&nbsp;<span style="color: red;">*</span> -->
                <b-input-group class="mb-3">
                    <b-form-input class="input" type="text"   v-validate="'required'" id="branchname" name="branchname" v-model="customer.branchname" :class="{
                        input: true,'is-invalid': errors.has('form-5.branchname'),}" placeholder="Enter Branch Name"></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('branchname')"></i>
                    </span>
                    <code v-show="errors.has('form-5.branchname')" id="branchnameerrmsg" class="help text-danger">{{ errors.first("form-5.branchname") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    Account number<span style="color: red;">&nbsp;*</span>
                </template>
                <!-- <label for="accountnumber">Account number</label>&nbsp;<span style="color: red;">*</span> -->
                <b-input-group class="mb-3">
                    <b-form-input class="input"  v-validate="'required'" type="text" id="accountnumber" name="accountnumber" v-model="customer.accountnumber" :class="{
                        input: true,'is-invalid': errors.has('form-5.accountnumber'),}" placeholder="Enter Account number"></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('accountnumber')"></i>
                    </span>
                    <code v-show="errors.has('form-5.accountnumber')" id="accountnumbererrmsg" class="help text-danger">{{ errors.first("form-5.accountnumber") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group :label-cols="4">
                  <template v-slot:label>
                    IFSC Code<span style="color: red;">&nbsp;*</span>
                </template>
                <!-- <label for="ifsccode">IFSC Code</label>&nbsp;<span style="color: red;">*</span> -->
                <b-input-group class="mb-3">
                    <b-form-input class="input"  v-validate="'required'" type="text" id="ifsccode" name="ifsccode" v-model="customer.ifsccode" :class="{
                        input: true,'is-invalid': errors.has('form-5.ifsccode'),}" placeholder="Enter IFSC Code"></b-form-input>
                </b-input-group>
                <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('ifsccode')"></i>
                    </span>
                    <code v-show="errors.has('form-5.ifsccode')" id="ifsccodeerrmsg" class="help text-danger">{{ errors.first("form-5.ifsccode") }}
                    </code>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="4">
              <button type="button" class="btn btn-outline-success btn-md" v-if="showverifybutton" @click="verifyGSTNo()">Verify</button>&nbsp;
              <button type="button" class="btn btn-outline-danger btn-md" v-if="removeGST" @click="removevalue()">X</button>
            </b-col>
          </b-row>
          <hr />
            <br />
            <h6 v-if="vehicle_historylog.length > 0" style="text-align:center"><b>Vehicle Details Change History</b></h6>

            <div class="col-md-12 px-0 mt-2 ml-0 d-block"  v-if="vehicle_historylog.length > 0">
            <table class="table table-bordered table-hover">
             <thead>
               <tr>
                   <th>Vehicle Updated From</th>
                   <th>Vehicle Updated To</th>
                   <th>Vehicle Updated On</th>
                   <th>Vehicle Updated By</th>
                   <th>Comment</th>


               </tr>
           </thead> 
           <tbody v-if="vehicle_historylog.length > 0">
             <tr v-for="(data,key) in vehicle_historylog">
                   <td>{{data.updated_from == 'adhoc' ? data.updated_from : 'Regular' }}</td>
                   <td>{{data.updated_to == 'adhoc' ? data.updated_to : 'Regular'}}</td>
                   <td>{{ data.vehicle_updated_on | ConvertTime12hour() }}</td>
                   <td>{{data.vehicle_updated_by}}</td>
                    <td>{{ data.changecomment }}</td>
               </tr>
           </tbody>
           </table>
         </div>
            
            <hr v-if="vehicle_historylog.length > 0" />
              <br>
          <div slot="footer" class="text-right">
            <div id="overlayModal">
              <div class="loaderModal"></div>
            </div>
            <b-button type="submit" size="sm" class="mr-4" variant="primary" id="submitButton" v-if="HideAnyAction!='Yes'">
              Update</b-button
            >
            <b-button size="sm" variant="danger" @click="editcancel()"
              >cancel</b-button
            >
          </div>
        </b-form>
               
        </div>
              <!-- adhic END -->
          </b-col>
      </b-row>
        

      </template>
      <template slot="modal-footer" slot-scope="{ hide }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" style="display:none">
          Cancel
        </b-button>
        <!-- Button with custom close trigger value -->
      </template>
    </b-modal>

    <!-- End -->

    <!-- Edit Vehicle Admin -->
    <b-modal title="Edit Vehicle Admin" size="md" v-model="vehicleCityWHmodal" @ok="vehicleCityWHmodal = false" hide-footer>
      <template slot="default" slot-scope="{ hide }">
        <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
          <div class="modal-card">
            <section class="modal-card-body">
              <b-col sm="12">
                <b-row>
                  <b-col sm="4" class="pr-0">
                    <label><b>Select Admin</b></label>&nbsp;<span style="color: red;">*</span>
                  </b-col>&nbsp;
                  <b-col sm="7" class="pl-0">
                    <div id="container">
                      <b-form-group>
                        <ejs-multiselect
                        id="multi_select"
                        placeholder="Select Admin"
                        v-model="valueAdmin"
                        @change="selectAdmin"
                        :dataSource="optionsAdmin"
                        :fields="fieldAdmin"
                        name="Admin"
                        v-validate="'required|'"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.Admin'),
                          }" 
                        ></ejs-multiselect>
                        <span
                          v-show="errors.has('form-1.Admin')"
                          class="help text-danger"
                          >{{ errors.first("form-1.Admin") }}</span
                        >
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
              </b-col>

              <b-col sm="12">
                <b-row>
                  <b-col sm="4" class="pr-0">
                    <label><b>Select City</b></label>&nbsp;<span style="color: red;">*</span>
                  </b-col>
                  <b-col sm="8" class="pl-0">
                    <div id="container">
                      <b-form-group>
                        <ejs-multiselect 
                        id="multi_select" placeholder="Select City" v-model="valueWHAdmin" @change="selectWHAdmin" :dataSource="warehouseAdmin" :fields="fieldwhAdmin" name="City" v-validate="'required'" :class="{ input: true, 'is-invalid': errors.has('form-1.City'),}">
                      </ejs-multiselect>
                        <span
                        v-show="errors.has('form-1.City')"
                        class="help text-danger"
                        >{{ errors.first("form-1.City") }}</span
                      >
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </section>
            <footer class="text-right">
              <div id="overlayModal">
                <div class="loaderModal"></div>
              </div>
              <b-button size="sm" variant="primary" type="submit" class="mr-4"
              v-if="HideAnyAction!='Yes'">Update</b-button
              >
              <b-button size="sm" variant="danger" @click="editCityWHcancel()">
                Cancel
              </b-button>
            </footer>
          </div>
        </form>
      </template>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          size="sm"
          variant="danger"
          @click="vehicle()"
          style="display:none"
        >
          Cancel
        </b-button>
        <!-- Button with custom close trigger value -->
      </template>
    </b-modal>

    <!-- change password -->
    <b-modal
      title="Change Password"
      size="md"
      v-model="resetPassword"
      @ok="resetPassword = false"
      hide-footer>
      <template slot="default" slot-scope="{ hide }">
        <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
          <div class="modal-background"></div>
          <div class="modal-card">
            <section class="modal-card-body">
              <div class="field">
                <p class="control">
                  <span style="color: red;"
                    >Strong Passowrd Rules:<br />

                    1)Your password must be between 6 to 14 character<br />
                    2)Password must contain at least one lowercase and uppercase
                    character<br />
                    3)Password must contain at least one number<br />
                    4)Password must contain at least one special character
                    <br />
                  </span>
                  <b-form-input
                    class="input"
                    type="text"
                    name="password"
                    minlength="6"
                    maxlength="14"
                    v-model="customer.deliveryagentpassword"
                    v-validate="{
                      required: true,
                      regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,12})/,
                    }"
                    :class="{
                      input: true,
                      'text-danger': errors.has('form-4.password'),
                    }"
                    placeholder="Enter password"
                  />
                  <code
                    v-show="errors.has('form-4.password')"
                    class="help text-danger"
                    >{{ errors.first("form-4.password") }}</code
                  >
                </p>
              </div>
            </section>
            <footer class="text-right">
              <div id="overlayModal">
                <div class="loaderModal"></div>
              </div>
              <b-button size="sm" variant="primary" type="submit" class="mr-4"
              v-if="HideAnyAction!='Yes'">Update</b-button
              >
              <b-button size="sm" variant="danger" @click="cancelPassword()">
                Cancel
              </b-button>
            </footer>
          </div>
        </form>
      </template>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          size="sm"
          variant="danger"
          @click="cancel()"
          style="display:none"
        >
          Cancel
        </b-button>
        <!-- Button with custom close trigger value -->
      </template>
    </b-modal>

    <!-- Available Vehicle model -->
    <b-modal  title="Available Vehicle List"
    size="xl" v-model="availablevehiclemodel" @ok="availablevehiclemodel==false" hide-footer>
    <b-col sm="12" class="text-right">
      <p>
        <b
          >Total Records :<span style="color:red;">{{
            totalvehiclelist
          }}</span></b
        >
      </p>
    </b-col>
      <b-table
        show-empty
        responsive
        :busy="isBusyvlist"
        :items="available_vehiclelist"
        :fields="availablevehiclefields"
        :bordered="bordered"
        :filter="vehiclefilter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
      >
        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template slot="drivername" slot-scope="row">
          <span
            >{{ row.item.driverfirstname }}
            {{ row.item.driverlastname }}</span
          >
        </template>
      </b-table>
    </b-modal>

     <!-- pending vehicle master start here-->
      <b-modal  title="Freight Add/Update"  size="lg" v-model="updateInfo" @ok="updateInfo==false" hide-footer class="text-center">
                  <b-row>
                    <b-col sm="12">   
                      <b-form @submit.prevent="editFreightApprovalandRejectForm('form-10','approveIncident')" data-vv-scope="form-10" class="text-center">
                            <b-row class="mb-4 text-center">
                                <div class="col-12">
                                Please Confirm the registration
                                of the below vehicle.
                                </div>
                            </b-row>
                            <b-row class="mb-4">
                                <div class="col-3">
                                    <div><strong>Transporter Name</strong></div>
                                    <div>{{ updatetFreightVehicleObj.transporter_name }}</div>
                                </div>
                                <div class="col-3">
                                        <div><strong>Vehicle No</strong></div>
                                        <div>{{ updatetFreightVehicleObj.vehicle_no }}</div>
                                    </div>
                                    <div class="col-3">
                                        <div><strong>Vehicle vol. wt.</strong></div>
                                        <div>{{updatetFreightVehicleObj.vehicleweightcarrying}}</div>
                                    </div>
                                    <div class="col-3">
                                        <div><strong>Permit Of Vehicle</strong></div>
                                        <div>{{updatetFreightVehicleObj.vehicle_permit}}</div>
                                    </div>
                            </b-row>
                            <b-row class="mb-2">
                                <div class="col-4">
                                  <b-form-group label="Labor Charges *" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="number" id="laborCharges" step="0.01" name="laborCharges" v-model="updatetFreightVehicleObj.labour_charges" placeholder="Enter Labor Charges"   v-validate="'required|'" :class="{ input: true,'is-invalid': errors.has('form-10.laborCharges'),}"></b-form-input>
                                  </b-input-group>
                                   <code v-show="errors.has('form-10.laborCharges')" class="help text-danger">{{ errors.first("form-10.laborCharges") }}</code>
                                  </b-form-group>
                                </div>
                                <div class="col-4">
                                  <b-form-group label="Fixed KM's *" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="number" id="fixedkm" step="0.01" name="fixedkm" v-model="updatetFreightVehicleObj.fixed_kms" placeholder="Enter Fixed km's"  v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-10.fixedkm'),}"></b-form-input>
                                  </b-input-group>
                                   <code v-show="errors.has('form-10.fixedkm')" class="help text-danger">{{ errors.first("form-10.fixedkm") }}</code>
                                  </b-form-group>
                                </div>
                                <div class="col-4">
                                  <b-form-group label="Fixed Freight rate" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="number" id="fixedkmrate" step="0.01" name="fixedkmrate" v-model="updatetFreightVehicleObj.fixed_freightrate" placeholder="Enter Fixed rate" v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-10.fixedkmrate'),}"></b-form-input>
                                  </b-input-group>
                                  <code v-show="errors.has('form-10.fixedkmrate')" class="help text-danger">{{ errors.first("form-10.fixedkmrate") }}</code>
                                  </b-form-group>
                                </div>
                            </b-row>
                            <b-row class="mb-2">
                              <div class="col-4">
                                  <b-form-group label="Extra KM rate" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="number" step="0.01" id="extrakm" name="extrakm" v-model.number="updatetFreightVehicleObj.extra_kmrate" placeholder="Enter Extra km's rate"  v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-10.extrakm'),}"></b-form-input>
                                  </b-input-group>
                                  <code v-show="errors.has('form-10.extrakm')" class="help text-danger">{{ errors.first("form-10.extrakm") }}</code>
                                  </b-form-group>
                                </div>
                                <div class="col-4">
                                  <b-form-group label="Working days" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="number" id="workingday" name="workingday" v-model="updatetFreightVehicleObj.workingdays" placeholder="Enter Working Day"  v-validate="'required|numeric'" :class="{ input: true, 'is-invalid': errors.has('form-10.workingday'),}"></b-form-input>
                                  </b-input-group>
                                   <code v-show="errors.has('form-10.workingday')" class="help text-danger">{{ errors.first("form-10.workingday") }}</code>
                                  </b-form-group>
                                </div>
                                
                            </b-row>
                            <b-row>
                              <div class="col-7">
                              <b-form-group :label-cols="4"> 
                                <template v-slot:label>
                                  Payment Type
                                </template>
                                <b-form-radio-group 
                                        v-model="updatetFreightVehicleObj.paymenttype" 
                                        
                                        :options="[
                                            { text: 'Daily', value: 'tripend' }, 
                                            { text: 'Weekly', value: 'weekly' },
                                            { text: 'Monthly', value: 'monthly' }
                                        ]"
                                        name="paymenttype" v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-10.paymenttype'),}
                                    ">
                                  </b-form-radio-group>
                                    <code v-show="errors.has('form-10.paymenttype')" class="help text-danger">{{ errors.first("form-10.paymenttype") }}</code>
                              </b-form-group>
                            </div>
                            </b-row>
                            
                            <footer class="column has-text-center mb-4">
                             
                              
                              <b-button variant="primary" size="md" type="submit" v-if="HideAnyAction!='Yes'">Confirm</b-button>
                              &nbsp;
                              <b-button variant="danger" size="md" @click.prevent="closePendingIncidentModal('approveIncident')">Close</b-button>
                            </footer>
                      </b-form>
                    </b-col>
                    <div id="listloader" v-if="loader">
                        <div class="listloader"></div>
                        <br/>
                       <span class="loading" style="color:#fff;">Loading...</span>
                      </div>
                  </b-row>
      </b-modal>

 <!-- Transporter Log Popup Modal -->
        <b-modal ref="transporterLogModal" title="Vehicle Log Details" hide-footer  size="xl">
          <div id="listloader" v-if="loader">
              <div class="listloader"></div>
              <br/>
              <span class="loading" style="color:#fff;">Loading...</span>
            </div>
            <div>
              <table class="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th>           
                    Sr.no
                    </th>
                    <th>ID</th>
                    <th>Transporter ID</th>
                    <th>Vehicle ID</th>
                    <th>Status</th>
                    <th>Createdby</th>
                    
                    <th> User Approval Level</th>
                      <th>Total Approval Levels</th>
                      <th>Reject Reason</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody v-if="arrTransporterLog.length > 0">
                  <tr v-for="(item, index) in arrTransporterLog" :key="index">
                    <td>{{(index+1)}}</td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.transporter_id }}</td>
                    <td>{{ item.vehicle_id }}</td>
                    <td>{{ item.status }}</td>
                    <td>{{ item.createdby }}</td>
                    <td>{{ item.user_approval_level }}</td>
                    <td>{{ item.total_approval_levels }}</td>
                    <td>{{ item.reject_reason }}</td>
                    <td>{{ formatDate(item.createdat) }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8">Records Not Created By Transporter</td>
                  </tr>
                </tbody>
              </table>
            </div>    
            <!-- Footer with Approve and Reject with Remark Buttons -->
            <div class="text-right mt-3"  v-if="arrTransporterLog.length > 0">    
              <b-button variant="secondary" @click="$refs.transporterLogModal.hide()">Close</b-button>
            </div>    
        </b-modal>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
const axios = require('axios')


 
export default {
 
  data: function() {
    return {
      name: "deliveryagentmaster",
      isBusy: false,
      arrTransporterLog:[],
      customer: {},
      // selected:'',
      seen: true,
      searchObj: {},
      totalCount: 0, 
      currentPage: 1, // Current page
      perPage: 100,
      resetPassword: false,
      editAgentMaster: false,
      toggleInfo: false,

      bordered: true,
      items: [],
      searchResults: [],

      searchResults1: [],
      fields: [
        {
          key: "vehicle_id",
          label: "Vehicle Id",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "drivername",
          label: "Driver Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "drivermobilenumber",
          label: "Driver Mobile No",
          sortable: true,
          sortDirection: "desc",
        },
        // { key: "vehicle_name", label: "Vehicle Name", sortable: true },

        { key: "vehicle_no", label: "Vehicle Number", sortable: true },
        { key: 'vehicle_origin', label: 'Vehicle Origin City', sortable: true, sortDirection: 'desc' },

        { key: "vehicletypesize", label: "Vehicle Type", sortable: true },
        { key: "vehicle_type", label: "Movement Type", sortable: true },
        { key: "paymenttype", label: "Payment Type", sortable: true },
        { key: "fueltype", label: "Fuel Type", sortable: true },
        { key: 'registration_no', label: 'Registration No', sortable: true},
        // { key: "vehicle_type", label: "Vehicle Type", sortable: true },
        { key: "isactive", label: "is Active", sortable: true },
        {
          key: "vehicleweightcarrying",
          label: "Volumetric Weight",
          sortable: true,
        },
        {
          key: "vehiclephysicalweight",
          label: "Physical Weight",
          sortable: true,
        },
                  { key: "invoice_status", label: "Approval Status", sortable: true },

        { key: "no_of_levels", label: "No Of Levels" },

        { key: "createddate", label: "Created Date", sortable: true },

        { key: "actions", label: "Actions" },
      ],
      userType: "",

      totalRows: 0,
      currentPage: 1,
      // perPage:20,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: true,
      sortDirection: "desc",
      vehiclefilter:'',
      vehicleCityWHmodal: false,
      cityData: [],
      adminData: [],
      optionsAdmin:[],
      userType: "",
      showSelectAll: true,
      valueAdmin: [],
      
      adminSysid: [],
      sysIdinlist: "",
      fieldAdmin: { text: "name", value: "id" },
      vehicle_Id: "",
      sysIdinlist: "",
      sysusermasterid: "",
      searchvaluesarr: [],
      avilablevehicle : "",
      availablevehiclemodel : false,
      available_vehiclelist : [],
      totalvehiclelist : 0,
      isBusyvlist : false,
      addInfoCard:false,
      updateInfo:false,
      updatetFreightVehicleObj :{},

      availablevehiclefields : [
        // { key: "vehicle_id", label: "Vehicle Id", sortable: true,
        //   sortDirection: "desc",},
        { key: "vehicle_no", label: "Vehicle Number", sortable: true },

        { key: "drivername", label: "Driver Name", sortable: true, sortDirection: "desc" },

        { key: "drivermobilenumber", label: "Driver Mobile No", sortable: true, sortDirection: "desc" },

        { key: "vehicle_name", label: "Vehicle Name", sortable: true },

        // { key: "vehicle_no", label: "Vehicle Number", sortable: true },

        { key: "vehicleweightcarrying", label: "Volumetric Weight",
          sortable: true},

        { key: "vehiclephysicalweight", label: "Physical Weight",
          sortable: true},

        { key: "createddate", label: "Created Date", sortable: true },
      ],
      sendadminid : [],
      adminWHid: [],
      warehouseData: [],
      warehouseAdmin: [],
      valueWHAdmin :[],
      fieldwhAdmin: { text: "name_wh", value: "id_wh" },
      WHid :'',
      helper_data :[],
      transporter_id:null,
      mailitems :[],
      optionmailid :[],
      transporterCompanyName:null,
      errors_GST:false,
      errors_showGST:{},
      removeGST:false,
      showverifybutton : false,
      driver_data:[],

      vehicleNameOptions:[],
      vehicleTypeSizeOptions:[],
      fuelTypeOptions:[],
      vehiclenametext:false,
      vehicletypesizetext:false,
      vehiclenameflag:false,
      vehicleName_id:null,
      vehicleTypeSize_id:null,
      fuelType_id:null,
      isActive: false,        
      adhoc_vehicle_edit:'',
      regular_vehicle_edit: '',
      selectedVehicle: null,
       otransporteremail:[],
       oldvehicledata:[],
       getoldvehicletype:null,
       vehicle_historylog:[],
       getmyvehicleid:null,
       regularkeyMap: {
  "vehiclename": "Vehicle Name",
  "vehiclenametext": "Vehicle Name",
  "editvehicleno": "Vehicle Number",
  "registration_no": "Registration No",
  "vehicletype": "Movement Type",
  "vehicletypesize": "Vehicle Type",
  //"vehicletypesizetext": "Vehicle Type",
  "vehicleweightcarrying": "Vol Weight",
  "vehiclephysicalweight": "Phy Weight",
  // "vehicledimensionsweight": "Dimensions Weight",
  "fueltype": "Fuel Type",
  "driverfirstname": "Driver First Name",
  "driverlastname": "Driver Last Name",
  "mobile_no": "Driver Mobile No",
  "altmobile_no": "Driver Alt Mobile No",
  "driving_license": "Driving License",
  "helperfirstname": "Helper First Name",
  "helperlastname": "Helper Last Name",
  "helpermobilenumber": "Helper Mobile no",
  "helperaltmobilenumber": "Helper Alt Mobile no",
  "transporterCompanyName": "Transporter Company Name",
  "driver_contracter_name": "Transporter Name",
  "contractormobilenumber": "Transporter Mobile No",
  "contracter_emailid": "Transporter Email ID",
  "transporter_gstnumber": "Transporter Tin Number / GST Number",
  "isactive": "Driver Status",
  "drivermobilenumber":"Driver Mobile No"
      },
      getfullname:null,
      accessBody:[],
      isReadOnly:false,
      selectedBankCheque: '',
      pincodes: [],
      pincodeCityData: [],
      bankFileName: '',
      bankcancelledcheque: '',
      bankFileType: '',
      selectedGstinCertficate: '',
      gstincertificate: '',
      gstinCertficateType: '',
      gstinCertficateFilename: '',
      tripLevelInvoiceApproval: null,
      tripLevelInvoiceApprovalLevel:null,
      adminHub:{},
            optionHubid:[],
            hubList:[],
            dlFileName: '',
      dlFileType: '',
      selectedDl: '',
      licence_url: '',
      pucFileUplodFilename: '',
      pucFileUplod: '',
      pucFileUplodType: '',
      puc_url: '',
      selectedRegistration: '',
      registrationFilename: '',
      registrationFileType: '',
      registration_url: '',
      selectedPermit: '',
      permitFileName: '',
      permitFileType: '',
      permit_url: '',
      selectedInsuranceFile: '',
      insurance_url: '',
      fixedFreightCostEdit:'',
      fixedFreightPerDayEdit:'',
      fixedLabourPerDayEdit:'',
    };
  },
  created: function() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    console.log('userInfouserInfouserInfouserInfo Register',userInfo);
    if (userdata && userInfo.approval_action && userInfo.approval_action!='') {
      this.tripLevelInvoiceApproval = userInfo.approval_action.find(action => action.module === "vehicle_freight_charges");
      // Log the result (or handle it as needed)
      if (this.tripLevelInvoiceApproval && this.tripLevelInvoiceApproval.level) {
        this.tripLevelInvoiceApprovalLevel = this.tripLevelInvoiceApproval.level.replace('l', '');
      }
      console.log('tripLevelInvoiceApproval Level',this.tripLevelInvoiceApprovalLevel);
    }
    this.userType = userInfo.user_type;
    console.log("YYUUUU", this.userType);
    this.user_id = userInfo.sysusermasterid;
    let firstname = userInfo.userfirstname ? userInfo.userfirstname : ''
    let lastname = userInfo.userlastname ? userInfo.userlastname : ''
     this.getfullname = firstname +" "+ lastname
    // this.toggle();
    this.accessBody = userInfo.body;
    console.log("--------->>>>>>>>>>",userInfo.body)
    this.ischeckbodyvalidation();

    this.displaydata();
    this.getVehicleDetailsList();
    this.getPincodeList();

  },
  props:['HideAnyAction','vehicleidDetails'],

  computed: {
    currentComponent() {
      console.log('Current Component:', this.isActive ? 'AdhocVehicleEdit' : 'RegularVehicleEdit');
          return this.isActive ? 'adhoc_vehicle_edit' : 'regular_vehicle_edit';
      },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    
  },
  mounted: function () {
    console.log('Button clicked--->',this.optionsAdmin) 
  },
  watch: {
  isActive(newValue) {
    if (newValue) {
      // this.editinfoModal();
    } else {
      // this.editinfoModal();
    }
  }
},
  methods: {
  calculateFreightCostEdit() {
      let workingdaysEdit =this.customer.workingdays || 0;
      let labourChargesEdit =this.customer.labour_charges || 0;
      let kms = parseFloat(this.customer.fixed_kms) || 0;
      let rate = parseFloat(this.customer.fixed_freightrate) || 0;
      
      this.fixedFreightCostEdit = (kms * rate).toFixed(2);
      this.fixedFreightPerDayEdit = (this.fixedFreightCostEdit && this.fixedFreightCostEdit!='0.00') ? parseFloat((this.fixedFreightCostEdit / workingdaysEdit).toFixed(2)): 0;
      this.fixedLabourPerDayEdit= labourChargesEdit ? parseFloat((labourChargesEdit/workingdaysEdit).toFixed(2)): 0;
  },
   formatStatus(item) {
      // Assuming both fields exist in the item object
      const invoiceStatus = item.approver_status || 'N/A'; // Default if null
      const nextReviewer = item.nextreviewer ? `L${item.nextreviewer}` : ''; // Prefix with 'L' if exists
      // Return values based on condition
      return nextReviewer ? `${nextReviewer} - ${invoiceStatus}` : invoiceStatus;
    },
   formatDate(date) {
      if (!date) return 'N/A'; // Fallback if date is null or undefined
      const parsedDate = new Date(date);
      return parsedDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    transporterMasterLog(transporter_id,vehicle_id) {   
      console.log('transporterMasterLog',transporter_id);
      this.remark = '';
       this.loader = true;
      const obj = {
        transporterId: transporter_id,
        type:'vehicle',
        vehicleId:vehicle_id,
      };
      console.log('-------transporterMasterLog-------',obj);

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterMasterLog`, obj).then(result => {
        console.log('getTransporterMasterLog',result.body);
         this.loader = false;
        if (result.body.returnstatus === 'Successful') {
          this.arrTransporterLog = result.body.returnvalue;
        } else {
          this.arrTransporterLog = [];
        }
      }).catch(ex => {
        console.error('Error fetching invoice list:', ex);
      }).finally(() => {
        this.loader = false;
      });

      // Show dispute confirmation modal
      this.$refs.transporterLogModal.show();
    },
  updateModal(vehicle_no){
        console.log(vehicle_no, 'dataataatataat');
        this.addInfoCard = false
        this.updatetFreightVehicleObj={};
         var userdata = localStorage.getItem('userData')
         var userInfo = JSON.parse(userdata)
          var apiObj = {         
             VehicleNo:vehicle_no
           };
         console.log("JJJJJ",apiObj);
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getVehiclesBasedOnVehicleNo`, apiObj)
          .then(result => {
            
           document.getElementById("overlay").style.display = "none";
           if(result.body.returnmsg=="Successful")
            {
            const datareturnvalue=result.body.returnvalue;

            if(Array.isArray(datareturnvalue) && datareturnvalue.length > 0 ){
            const data=datareturnvalue[0];
            console.log('getVehiclesBasedOnVehicleNo',data);
            this.updatetFreightVehicleObj.transporter_id=data.transporter_id
            this.updatetFreightVehicleObj.vehicle_no =data.vehicle_no
            this.updatetFreightVehicleObj.transporter_name =data.transporter_name
            this.updatetFreightVehicleObj.vehicle_permit =data.vehicle_permit_of_vehicle
            this.updatetFreightVehicleObj.vehicleweightcarrying =data.vehicleweightcarrying
            this.updatetFreightVehicleObj.drivermobilenumber =data.drivermobilenumber
            this.updatetFreightVehicleObj.vehicle_id =data.vehicle_id
            this.updatetFreightVehicleObj.no_of_levels =data.no_of_levels
            this.updatetFreightVehicleObj.nextreviewer =data.nextreviewer
            this.updatetFreightVehicleObj.labour_charges =data.labour_charges
            this.updatetFreightVehicleObj.fixed_kms =data.fixed_kms
            this.updatetFreightVehicleObj.fixed_freightrate =data.fixed_freightrate
            this.updatetFreightVehicleObj.extra_kmrate =data.extra_kmrate
            this.updatetFreightVehicleObj.workingdays =data.workingdays
            this.updatetFreightVehicleObj.paymenttype = data.paymenttype

         }
            this.updateInfo = !this.updateInfo;
            
        
            }else{
                this.$fire({
                  text:"Can not records",
                  type: "error",
                  timer: 30000
                }); 
            }

          }) .catch(ex => {
            console.log("error-----", ex);
          });

       
        },
      editFreightApprovalandRejectForm(scope,reason){
        this.$validator.validateAll(scope).then((result) => {
        if (result) {
            // this.editTransporterInfo();
            this.PendingIncidentBtn(this.updatetFreightVehicleObj, reason)
        }
        });
      },
      PendingIncidentBtn(updatetFreightVehicleObj, reason) {
        // if (reason === 'rejectIncident') {
        //     this.loader=true;
        //   let userdata = localStorage.getItem("userData");
        //   let userInfo = JSON.parse(userdata);
        //       const infoObj = {
        //           reject_reason: this.updatetFreightVehicleObj.rejectReason,
        //           vehicle_id:this.updatetFreightVehicleObj.vehicle_id, 
        //           no_of_levels:this.updatetFreightVehicleObj.no_of_levels, 
        //           nextreviewer:this.updatetFreightVehicleObj.nextreviewer, 
        //           user_approval_level:this.updatetFreightVehicleObj.nextreviewer,
        //           lastmodifiedby:`${userInfo.sysemailid}`,     
        //       };
        //       console.log("infoObj",infoObj);
        //       // return false;
        //   this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/rejectFreightPendingVehicle`, infoObj).then((result)=>{
        //     this.loader=false;
        //     if (result.body.returnmsg === "Successful") {
        //       this.$fire({
        //         text: result.body.returnvalue,
        //         type: "success",
        //         timer: 30000,
        //       });
        //      this.closePendingIncidentModal(reason);
        //       this.displaydata();
        //     } else {
        //       this.$fire({
        //         text: result.body.returnvalue,
        //         type: "error",
        //         timer: 30000,
        //       });
        //     }
        //   }).catch((ex) => {
        //     console.log("error", ex);
        //   });
        // }

        if (reason === 'approveIncident') {
          this.loader=true;
          let userdata = localStorage.getItem("userData");
          let userInfo = JSON.parse(userdata);
              const infoObj = {
                  vehicle_id:this.updatetFreightVehicleObj.vehicle_id, 
                  no_of_levels:this.updatetFreightVehicleObj.no_of_levels, 
                  labour_charges:this.updatetFreightVehicleObj.labour_charges, 
                  fixed_kms:this.updatetFreightVehicleObj.fixed_kms, 
                  fixed_freightrate:this.updatetFreightVehicleObj.fixed_freightrate, 
                  extra_kmrate:this.updatetFreightVehicleObj.extra_kmrate, 
                  workingdays:this.updatetFreightVehicleObj.workingdays, 
                  user_approval_level:this.updatetFreightVehicleObj.nextreviewer,
                  payment_mode:this.updatetFreightVehicleObj.paymenttype,
                  lastmodifiedby:`${userInfo.sysemailid}`,               
              };

              console.log("infoObj",infoObj);
             // return false;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approveRegisteredVehicle`, infoObj).then((result)=>{
            this.loader=false;
            if (result.body.returnmsg === "Successful") {
              
              this.$fire({
                text: result.body.returnvalue,
                type: "success",
                timer: 30000,
              });
             
             this.closePendingIncidentModal(reason);              
             this.displaydata();

            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          }).catch((ex) => {
            console.log("error", ex);
          });
        }
        
      },
      closePendingIncidentModal(close) {
        this.updatetFreightVehicleObj={};
        if (close === 'approveIncident') {
          this.updateInfo = false;
        }
      },
      downloadFile(fileUrl) {
          
          // Open the file URL in a new tab
          if (fileUrl) {
              window.open(fileUrl, '_blank');
          } else {
            this.$fire('No file available for download!', {
                  title: 'Error',
                  variant: 'danger',
                  solid: true,
              });
          }
      },
      selectBankChequeFile(event){
            this.selectedBankCheque= event.target.files[0];            
            if (this.selectedBankCheque) {
                this.bankFileName = `${event.target.files[0].name}`; 
            }
            this.bankFileType = this.selectedBankCheque.type;
            this.uploadBankCheque(this.selectedBankCheque);
        },

        uploadBankCheque : function () {
        document.getElementById("overlayModal").style.display = "block";
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedBankCheque)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
              document.getElementById("overlayModal").style.display = "none";

                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.bankcancelledcheque=response.data.image_url;  
                   this.customer.bankcancelledcheque=response.data.image_url;             
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },

        selectGstinCertficateFile(event){
            this.selectedGstinCertficate= event.target.files[0];            
            if (this.selectedGstinCertficate) {
                this.gstinCertficateFilename = `${event.target.files[0].name}`; 
            }
            this.gstinCertficateType = this.selectedGstinCertficate.type;
            this.uploadGstin(this.selectedGstinCertficate);

        },

        uploadGstin : function () {
        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedGstinCertficate)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.gstincertificate=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error in upload GSTIN certificate',e);
                
            })
        
        },
    ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Vehicle Master' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Vehicle Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
    updatedetails() {
      console.log("save suuceess----sangam",this.editAgentMaster);
      this.displaydata();
      this.getVehicleDetailsList();
      // if(this.editAgentMaster)
      // this.editAgentMaster = !this.editAgentMaster;
      // else
      // this.editAgentMaster = this.editAgentMaster;
      
      
    },
    toggle() {
      console.log('Button clicked-sangam--->',this.isActive);
      if (!this.isActive) {
        this.$fire({
          text: "Are you sure you want to update vehicle as Adhoc Vehicle",
          type: "success",
          timer: 300000,
          iconHtml: '',
          showCancelButton: true,
          icon: 'none',
          confirmButtonColor: 'grey',
          cancelButtonColor: 'grey',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then((response) => {
          console.log("--->", response);
          if (response.dismiss != 'cancel') {
            this.isActive = !this.isActive;
          }
        });
      } else {
        this.isActive = !this.isActive;
      }
      // Swal.fire({
      //   title:"Are you sure you want to update vehicle as Adhoc Vehicle",
      //   icon: "error",
      // }).then((response) => {
      //   if (response) {
      //   this.isActive = !this.isActive;   
      //   }
      // });
      // this.isActive = !this.isActive; // toggle the state
      // if (this.isActive) {
      //   vehicletype = 'adhoc_vehicle_edit';
      // } 
      // if (!this.isActive) { 
      //   vehicletype = 'regular_vehicle_edit';
      // }
      // console.log('Toggle state:', this.isActive);
    },
    downloadvehiclereport(){
      document.getElementById("overlay").style.display = "block";
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
          var csvObj = {
            sysusermasterid:`${userInfo.sysusermasterid}`,
            usertype:`${userInfo.user_type}`,
             approver_status:'approved',
             tripLevelInvoiceApprovalLevel: this.tripLevelInvoiceApprovalLevel,
              vehicle_id: this.HideAnyAction=='Yes'?this.vehicleidDetails:'',
           };
            console.log("JJJJJ",csvObj);
        // console.log("csvObj",csvObj);
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getCSVForVehicleMaster`, csvObj)
          .then(result => {
            
          document.getElementById("overlay").style.display = "none";
           if(result.body=="success")
         {
         // alert("Please Check Ur Mail For Downlod Link")
         this.$fire({
                  text:"Please Check Your Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 
       }
       else
       {
        this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 
       }

          })
          .catch(ex => {
            console.log("error-----", ex);
          });
    },

    // displaydata: function() {
    //   // alert("innnn");
    //   this.items = [];

    //   this.totalRows =0;
    //   this.isBusy = true;
    //   var userdata = localStorage.getItem("userData");
    //   var userInfo = JSON.parse(userdata);
    //   const deliveryagentobj = {
    //     sysusermasterid: `${userInfo.sysusermasterid}`,
    //     usertype: `${userInfo.user_type}`,
    //   };
    //   console.log("deliveryagentobj", deliveryagentobj);
    //   this.$http
    //     .post(
    //       `${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`,
    //       deliveryagentobj
    //     )
    //     .then((result) => {
    //       console.log("YYY", result);
    //       this.isBusy = false;
    //       if (result.body.length > 0) {
    //         this.data = result.body;

    //         this.items = result.body;

    //         this.totalRows = result.body.length;
    //         console.log("RRRR", this.totalRows);
    //       } else {
    //         // this.isBusy = false;
    //         this.data = result.body;
    //         this.items = result.body;
    //         this.totalRows = result.body.length;
    //       }
    //     })
    //     .catch((ex) => {
    //       console.log("error", ex);
    //     });
    // },

  displaydata: function(page = this.currentPage) {
      // alert("innnn");
      this.items = [];
      this.currentPage = page; // Update current page

      this.totalRows =0;
      this.isBusy = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const deliveryagentobj = {
        page: this.currentPage, 
        pageSize: this.perPage,
        // sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
        approver_status:'approved',
        //tripLevelInvoiceApprovalLevel:this.tripLevelInvoiceApprovalLevel 
        vehicle_id: this.HideAnyAction=='Yes'?this.vehicleidDetails:'',
        vehiclefilter: this.vehiclefilter,
      };
      console.log("deliveryagentobj", deliveryagentobj);
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/getVehiclesBasedOnStatus`,
          deliveryagentobj
        )
        .then((result) => {
          console.log("YYY", result);
          this.isBusy = false;
          if (result.body.returnmsg==='Successful') {
             this.data = result.body.returnvalue;
  
              this.items = result.body.returnvalue;
  
             // this.totalRows = result.body.returnvalue.length;
                this.totalCount = result.body.returnvalue[0].totalcount1;
             this.totalRows = result.body.returnvalue[0].totalcount1;

           // this.totalCount = result.body.totalcount;
           // this.totalRows = result.body.totalcount;
            } else {
              this.data = [];
              this.items = []
              this.totalRows = 0;
              this.totalCount =0;
            }

        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    

    addVehicleName:function(){
      this.customer.vehiclenametext='';
      console.log(this.customer.vehiclename)
      if(this.customer.vehiclename=='Other'){
        this.vehiclenametext=true;
      }
      else{
        this.vehiclenametext=false;
      }
    },

    addVehicleTypeSize:function(){
      this.customer.vehicletypesizetext='';
      if(this.customer.vehicletypesize=='Other'){
        this.vehicletypesizetext=true;
      }
      else{
        this.vehicletypesizetext=false;
      }
    },

    searchInLoadManagement() {
      this.searchvaluesarr = [];
      this.searchvaluesarr.push(this.vehiclefilter);
      console.log("YYY", this.searchvaluesarr);
      this.displaydata();
    },

    clearSearch() {
      this.vehiclefilter = "";
      this.displaydata();
    },

    useradd: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
    },

    refresh: function() {
      this.displaydata();
    },

    onBlur: function(deliveryagentmasterid) {
      document.getElementById("msg" + deliveryagentmasterid).style.color = "";
      document.getElementById("msg" + deliveryagentmasterid).innerHTML = "";
      document.getElementById("msg" + deliveryagentmasterid).style.display =
        "none";
    },

    chkmobileVal() {
      var chkValidate = true;
      // var chknumb = /^[0789]{1}\d{9}$/;
      var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

      var mobilenumber = document.getElementById("addmobilenumber").value;
      if (
        mobilenumber.trim() === "0000000000" ||
        mobilenumber.trim().length < 10
      ) {
        chkValidate = false;
        return false;
      } else if (
        mobilenumber.trim() != "" &&
        !mobilenumber.trim().match(chknumb)
      ) {
        chkValidate = false;
        return false;
      }
      return (chkValidate = chkValidate);
    },

    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.changeVehiclePassword();
        }
      });
    },

    validateForm5(scope) {
      console.log("validateForm5---->");
      this.$validator.validateAll(scope).then((result) => {
        console.log("Innnnnnnn---->",result);
        if (result) {
          this.updateDeliveryAgent();
        }
      });
    },

    validateForm6(scope) {
     console.log('here----------->')
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.updateDeliveryAgentAdhoc();
        }
      });
    },
    changeVehiclePassword: function() {
      document.getElementById("overlayModal").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      console.log("this.vehicle_id", this.vehicle_id);
      const encryptedText = btoa(this.vehicle_id);
       let firstname = userInfo.userfirstname ? userInfo.userfirstname : ''
      let lastname = userInfo.userlastname ? userInfo.userlastname : ''
     let fullname = firstname +" "+ lastname
      console.log("encryptedText", encryptedText);
      const decryptedText = atob(encryptedText);
      console.log("decryptedText", decryptedText);
      var passwObj = {
        vehicle_id: encryptedText,
        password: this.customer.deliveryagentpassword.trim(),
        lastmodifiedby:fullname
      };
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/changeVehicleUserPassword`,
          passwObj
        )
        .then((result) => {
          // console.log("error",result);
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg == "Successful") {
            this.$fire({
              text: "Password Updated Successfully",
              type: "success",
              timer: 300000,
            });

            this.resetPassword = false;
            this.customer = {};
            this.displaydata();
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 300000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    cancel: function() {
      this.customer = {};
      this.customer = {};
      this.editAgentMaster = !this.editAgentMaster;
    },

    editcancel: function() {
      this.customer = {};
      this.customer = {};
      if (this.isActive) {
        this.toggle(); // Call toggle to reset if it's active
      }
      this.editAgentMaster = false
    },

    editinfoModal: function(value) {
      // this.oldvehicledata = value
      this.adminWiseHubList(value.hubid);
      this.getoldvehicletype = value.vehicle_type
      // this.selected_type = value.vehicle_type;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.valueAdmin = [];
      this.optionsAdmin = [];
      this.editvehicleCityWH1(value);
      this.vehiclenametext=false;
      this.vehicletypesizetext=false;
      this.errors_GST =false;
      this.errors_showGST={};
      this.removeGST=false;
      this.showverifybutton = false;
      this.customer ={}
      this.errors_showGST.transporter_gstnumber = '';
      //this.EmailListing(value.transporter_id);
      this.EmailListingv1(value.transporter_id)
      this.helper_data=[];
      this.customer.driverfirstname = value.driverfirstname;
      this.customer.driverlastname = value.driverlastname;
      this.customer.drivermobilenumber = value.drivermobilenumber;
      // this.customer.vehicleno_prefix = value.vehicleno_prefix;
      // this.customer.vehiclename = value.vehiclename_id;
      console.log('value.vehiclename_id--------------',value.vehiclename_id,this.vehicleNameOptions);
      
      for (let i = 0; i < this.vehicleNameOptions.length; ++i) {
          if (value.vehiclename_id == this.vehicleNameOptions[i].value) {
            this.customer.vehiclename = this.vehicleNameOptions[i].text;
          }
        }
      // vehicle_name;
      this.vehicleName_id = value.vehiclename_id
      this.customer.vehicletype = value.vehicle_type;
      this.customer.fueltype = value.fueltype_id;
      //fueltype;
      this.fuelType_id = value.fueltype_id;
      this.customer.paymenttype = value.paymenttype;
      this.customer.vehicletypesize = value.vehicletype_size_id;
      // vehicletypesize
      this.vehicleTypeSize_id = value.vehicletype_size_id;
      this.getVehicleDetailsList();
      this.customer.registration_no = value.registration_no;
      //this.customer.vehiclemake = value.vehicle_make;
      this.customer.vehicleweightcarrying = value.vehicleweightcarrying;
      this.customer.vehiclephysicalweight = value.vehiclephysicalweight;
      // this.customer.vehicledimensionsweight = value.vehicledimensionsweight
      this.customer.editvehicleno = value.vehicle_no;
      this.customer.vehicleMasterid = value.vehicle_id;
      this.customer.isactive = value.isactive;
      this.customer.mobile_no = value.drivermobilenumber;
      this.customer.altmobile_no = value.driveraltmobilenumber;

      this.customer.helperfirstname = value.helperfirstname;
      this.customer.helperlastname = value.helperlastname;
      this.customer.helpermobilenumber = value.helpermobilenumber;
      this.customer.helperaltmobilenumber = value.helperaltmobilenumber;
      this.customer.contractormobilenumber = value.contractormobilenumber;

      this.customer.driving_license = value.driving_license;
      // if(value.transporter_id!=null){
      // this.customer.driver_contracter_name = value.drivercontractername;
      this.transporterCompanyName = value.transporter_company_name != null ? value.transporter_company_name : '';
      this.customer.driver_contracter_name = value.transporter_name;
      if(value.transporter_company_name){
            this.transporterCompanyName = value.transporter_company_name
          }else{
            this.transporterCompanyName= value.drivercontractername 
          }

          if (value.transporter_name) {
            this.customer.driver_contracter_name = value.transporter_name;
          }else{
            this.customer.driver_contracter_name = value.drivercontractername;
          }

          if (value.registered_from) {            
          if (value.registered_from.toLowerCase() == 'transporter_portal') {
            this.customer.bankname = value.bank_name;
            this.customer.branchname = value.branch_code;
            this.customer.bankaccountname = value.account_holder_name;
            this.customer.accountnumber = value.fastag_account_linked;
            this.customer.ifsccode = value.ifsc_pin;
            this.customer.aadhar = value.aadhar? value.aadhar : '';
            if (value.vehicle_type == 'adhoc') {
              this.customer.pan =  '',
              this.customer.aadhar = '';
            }else{
              this.customer.pan = value.pan ? value.pan : '';
              this.customer.aadhar = value.aadhar? value.aadhar : '';
            }
          }else{
            this.customer.bankname = value.bankname ? value.bankname : '';
            this.customer.bankaccountname = value.bankaccountname ? value.bankaccountname : '';
            this.customer.branchname = value.branchname ? value.branchname  : '';
            this.customer.accountnumber = value.accountnumber ? value.accountnumber : '';
            this.customer.ifsccode = value.ifsccode ? value.ifsccode : '';
            this.customer.aadhar = value.aadhar? value.aadhar : '';
            this.customer.pan = value.pan ? value.pan : '';

            if(this.customer.pincode){    
            this.pincodeChange(this.customer.pincode) 
          }
        
          }
        }else{
            this.customer.bankname = value.bankname ? value.bankname : '';
            this.customer.bankaccountname = value.bankaccountname ? value.bankaccountname : '';
            this.customer.branchname = value.branchname ? value.branchname  : '';
            this.customer.accountnumber = value.accountnumber ? value.accountnumber : '';
            this.customer.ifsccode = value.ifsccode ? value.ifsccode : '';
            this.customer.aadhar = value.aadhar? value.aadhar : '';
            this.customer.pan = value.pan ? value.pan : '';

          }
          this.customer.address = value.address ? value.address : '';
          this.customer.contracter_emailid = value.contracter_emailid || value.transporter_emailid;
          this.customer.transporter_gstnumber = value.transporter_gst_no
        this.transporter_id = value.transporter_id;
       // this.EmailListingv1(value.transporter_id)
        this.customer.transporterCompanyName = value.drivercontractername != null ? value.transporter_company_name : '';
        
        this.transporterCompanyName= value.drivercontractername != null ? value.transporter_company_name : '';
      // }
        this.customer.pincode = value.pincode  ? value.pincode.toString() : '',
        // this.customer.address = value.address ? value.address : '',
         this.customer.bankname = value.bankname ? value.bankname : '',
         this.customer.bankaccountname = value.bankaccountname ? value.bankaccountname : '',
         this.customer.branchname = value.branchname ? value.branchname  : '',
         this.customer.accountnumber = value.accountnumber ? value.accountnumber : '',
         this.customer.ifsccode = value.ifsccode ? value.ifsccode : '',
        // this.customer.aadhar = value.aadhar? value.aadhar : '',
        // this.customer.vendortype = value.vendortype ? value.vendortype : '',
        this.customer.vendortype = value.vendortype ? value.vendortype.toLowerCase() : '';
          if (value.vendortype == 'Owned') {
            this.customer.vendortype = 'normal'

          }
        this.customer.promotername = value.promotername ? value.promotername : '',

        // this.customer.gstinnumber = value.gstinnumber ? value.gstinnumber : '',
        this.customer.bankcancelledcheque= value.bankcancelledcheque ? value.bankcancelledcheque : '',

        this.customer.gstincertificate= value.gstincertificate ? value.gstincertificate : '',          
        this.customer.registration_url= value.registration_url ? value.registration_url: '',
        this.customer.puc_url = value.puc_url? value.puc_url: '',
        this.customer.pucnumberfile =   value.puc_url? value.puc_url.split('?key=')[1].split('-').pop(): '';          

        this.customer.insurance_url = value.insurance_url ? value.insurance_url : '',
        this.customer.permit_url = value.permit_url ? value.permit_url : '',
        this.customer.paymenttype = value.paymenttype ? value.paymenttype : '',
        this.customer.licence_url = value.licence_url ? value.licence_url : '',
        this.customer.labour_charges = value.labour_charges ? value.labour_charges : '',
        this.customer.fixed_kms = value.fixed_kms ? value.fixed_kms : '',
        this.customer.fixed_freightrate = value.fixed_freightrate ? value.fixed_freightrate : '',
        this.customer.extra_kmrate= value.extra_kmrate ? value.extra_kmrate : '';
        if (this.customer.paymenttype.toLowerCase() == 'monthly') {
            this.customer.workingdays = 31

          }else if(this.customer.paymenttype.toLowerCase() == 'weekly'){
            this.customer.workingdays = 7

          }else{
            this.customer.workingdays = 1
          }
          if(this.customer.pincode){    
          this.pincodeChange(this.customer.pincode)             
          }
       
          this.calculateFreightCostEdit();

        
        this.editAgentMaster = !this.editAgentMaster;
      // this.selectedVehicle = this.customer;
      
      // this.editWiseWarehouseList(value);
      // console.log("this.transporter_id ",this.transporter_id )
      let oldpayloaddata = {}
      oldpayloaddata.driverfirstname = value.driverfirstname;
      oldpayloaddata.driverlastname = value.driverlastname;
      oldpayloaddata.drivermobilenumber = value.drivermobilenumber;
      oldpayloaddata.vehiclename = value.vehicle_name;
      oldpayloaddata.vehicletype = value.vehicle_type;
      oldpayloaddata.fueltype = value.fueltype;
      oldpayloaddata.vehicletypesize = value.vehicletypesize;
      oldpayloaddata.registration_no = value.registration_no;
      oldpayloaddata.vehicleweightcarrying = value.vehicleweightcarrying;
      oldpayloaddata.vehiclephysicalweight = value.vehiclephysicalweight;
      // oldpayloaddata.vehicledimensionsweight = value.vehicledimensionsweight;
      oldpayloaddata.editvehicleno = value.vehicle_no;
      oldpayloaddata.isactive = value.isactive;
      oldpayloaddata.mobile_no = value.drivermobilenumber;
      oldpayloaddata.altmobile_no = value.driveraltmobilenumber;
      oldpayloaddata.helperfirstname = value.helperfirstname;
      oldpayloaddata.helperlastname = value.helperlastname;
      oldpayloaddata.helpermobilenumber = value.helpermobilenumber;
      oldpayloaddata.contractormobilenumber = value.contractormobilenumber;
      oldpayloaddata.driver_contracter_name = value.drivercontractername;
      oldpayloaddata.transporter_gstnumber = value.transporter_gst_no;
      oldpayloaddata.transporterCompanyName = value.drivercontractername != null ? value.transporter_company_name : '';
      oldpayloaddata.contracter_emailid = value.contracter_emailid
      oldpayloaddata.helperaltmobilenumber = value.helperaltmobilenumber;
      oldpayloaddata.driving_license = value.driving_license;


      this.oldvehicledata = oldpayloaddata
      this.getmyvehicleid = this.customer.vehicleMasterid
      this.VehicleListingLog(this.customer.vehicleMasterid)
 
    },
    adminWiseHubList(hub_id){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            // let sysId = this.valueAdmin.toString().split(",");
            let obj = {
                // sysusermasterid:sysId
            }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAdminHubListingNew`,obj)
            .then(result => {
                if(result.body.returnmsg === "Successful"){
                this.hubList  = result.body.returnvalue;
                var data = [];
                let newObj={};
                this.hubList.forEach(function (srData) {
                  if(hub_id==srData.hubid){
                    newObj={
                    key:srData.hubid,
                    label:srData.hubname + '-' + srData.hubid
                    };
                  }
                    data.push({
                    key:srData.hubid,
                    label:srData.hubname + '-' + srData.hubid
                    });
                });
                this.optionHubid = data;
                console.log('---------------------',newObj)
                this.adminHub=newObj;
                }
                else{
                  this.hubList=[];
                  this.optionHubid = [];
                }

            }).catch(ex => {
              console.log('error', ex)
            })
        },  
            
    editvehicleCityWH1: function(value) {
    console.log("Value",value);
    // document.getElementById("overlayModal").style.display = "block";
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.valueAdmin = [];
    this.optionsAdmin = [];
    // this.warehouseData = [];
      // this.warehouseAdmin = [];
      // this.valueWHAdmin = [];
      // this.valueWHAdmin=[];
    this.vehicle_Id = value.vehicle_id;
    this.sysIdinlist = value.sysusermasterid;
    this.WHid = value.warehouseid;
    // console.log("this.vehicle_Id=value.vehicle_id;",this.sysIdinlist);
    this.vehicle_Id = value.vehicle_id;

    if (this.WHid !=null) {
      this.adminWHid = this.WHid.split(",");
      console.log("YYYYYYYYYY", this.adminWHid);
      for (let i = 0; i < this.adminWHid.length; i++) {
        this.valueWHAdmin.push(this.adminWHid[i]);
      }
      console.log("this.valueWHAdmin",this.valueWHAdmin)
    }
    if (this.sysIdinlist != null) {
      this.adminSysid = value.sysusermasterid.split(",");
      // console.log("YYYYYYYYYY", this.adminSysid);
      for (let i = 0; i < this.adminSysid.length; i++) {
        this.valueAdmin.push(this.adminSysid[i]);
      }
    }

    const Obj = {
      sysusermasterid: `${userInfo.sysusermasterid}`,
      usertype: `${userInfo.user_type}`,
    };
    console.log("Obj", Obj);
    this.$http
      .post(`${CONSTANTS.MIGRATION_API_URL}/adminListingForVehicle`, Obj)
      .then((result) => {
        console.log("YYY", result);
        // document.getElementById("overlayModal").style.display = "none";
        if (result.body.returnmsg === "Successful") {
          this.adminData = result.body.returnvalue;
          for (let i = 0; i < this.adminData.length; i++) {
            let admin = {
              name:
                this.adminData[i].userfirstname +
                "" +
                this.adminData[i].userlastname +
                " - " +
                (this.adminData[i].user_type == 2 ? "Admin" : "Super Admin"),
              id: this.adminData[i].sysusermasterid.toString(),
            };

            this.optionsAdmin.push(admin);
            // console.log("HHHHAAAA",this.optionsAdmin);
          }
          // console.log(this.optionsAdmin);
        } else {
          this.adminData = result.body.returnvalue;
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
  },

    getVehicleDetailsList:function(){
       this.vehicleNameOptions=[];
          this.vehicleTypeSizeOptions=[];
          this.fuelTypeOptions=[];
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const Obj={

      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleDetailsList`, Obj)
      .then((result)=>{
        if(result.body && result.body.returnmsg== "Successful"){
          var vehicleNameData=result.body.returnvalue[0].vehicle_name;
          var vehicleTypeSizeData=result.body.returnvalue[0].vehicle_type;
          var fuelTypeData=result.body.returnvalue[0].fuel_Type;
                    
          for(let i=0;i<vehicleNameData.length;i++){
            this.vehicleNameOptions.push({
              value:vehicleNameData[i].id,
              text:vehicleNameData[i].value
            })
            if(i==vehicleNameData.length-1){
              this.vehicleNameOptions.push({
                text:'Other'
             })
            }
          }  
          console.log("vehicle Name Options-->",this.vehicleNameOptions)              

          for(let i=0;i<vehicleTypeSizeData.length;i++){
            this.vehicleTypeSizeOptions.push({
              value:vehicleTypeSizeData[i].id,
              text:vehicleTypeSizeData[i].value
            })
            if(i==vehicleTypeSizeData.length-1){
              this.vehicleTypeSizeOptions.push({
                text:'Other'
              })
            }
          }

          for(let i=0;i<fuelTypeData.length;i++){
            this.fuelTypeOptions.push({
              value:fuelTypeData[i].id,
              text:fuelTypeData[i].value
            })
          }
        }
        else{
          this.vehicleNameOptions=[];
          this.vehicleTypeSizeOptions=[];
          this.fuelTypeOptions=[];
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
    },

    updateDeliveryAgent: function() {

      document.getElementById("overlayModal").style.display = "block";
        console.log("this.customer.vehiclename",this.customer.vehiclename)
      var result = [];
      // alert("innnn");
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      
      if (this.customer.helperaltmobilenumber == this.customer.helpermobilenumber) {
        // alert("Alternate Mobile Number should be different from Mobile Number");
        this.$fire({
          text:
            "For Helper Alternate Mobile Number should be different from Mobile Number",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlayModal").style.display = "none";

        return false;
      }

         if(this.transporterCompanyName==null){
          document.getElementById("overlayModal").style.display = "none";
          this.$fire({
          text:"Please Select Transporter Company",
          type: "warning",
          timer: 30000,
          });
          document.getElementById("overlayModal").style.display = "none";

          return false;  
         }

        if(this.customer.driver_contracter_name == null || this.customer.contractormobilenumber == null || this.customer.contracter_emailid ==null){
          document.getElementById("overlayModal").style.display = "none";
          this.$fire({
            text:"Please Add Transporter Details From Transporter Master",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlayModal").style.display = "none";

          return false; 
        }

        if (this.customer.vehiclenametext =='Other' || this.customer.vehiclenametext =='other') {
          document.getElementById("overlayModal").style.display = "none";
          this.$fire({
            text: "Please Add New Vehicle Name",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlayModal").style.display = "none";

          return false;
        }
        let ologcommentdata = this.comparePayloadsWithKeyMap(this.oldvehicledata,this.customer,this.regularkeyMap)


         this.driver_data.push({
            driverfirstname: this.customer.driverfirstname.trim(),
            driverlastname: this.customer.driverlastname.trim(),
            drivermobilenumber: this.customer.mobile_no.trim(),
            driveraltmobilenumber: this.customer.altmobile_no.trim(),
            driving_license: this.customer.driving_license.trim(),
            driver_license_photo:'',
            driver_license_criteria:'',
            driver_email:'',                
            driver_adhar_no:'',
            driver_emergency_no:'',
            driver_adhar_photo:'',
            driver_language:[],
            driver_qualification:[]
          });
        this.helper_data.push({
            helperfirstname: this.customer.helperfirstname.trim(),
            helperlastname: this.customer.helperlastname.trim(),
            helpermobilenumber: this.customer.helpermobilenumber.trim(),
            helperaltmobilenumber: this.customer.helperaltmobilenumber.trim(),
            helper_license_number:"",
            helper_license_photo:"",
            helper_license_criteria:"",
            helper_email:"",
            helper_adhar_no:"",
            helper_adhar_photo:""
        });
                // console.log("this.helper_data",this.helper_data);

      var passwObj = {
        vehicleid: `${this.customer.vehicleMasterid}`,
        vehicleno: this.customer.editvehicleno.trim(),
        lastmodifiedby: `${userInfo.sysemailid.trim()}`,
        driverfirstname: this.customer.driverfirstname.trim(),
        driverlastname: this.customer.driverlastname.trim(),
        drivermobilenumber: this.customer.mobile_no.trim(),
        driveraltmobilenumber: this.customer.altmobile_no.trim(),

        //vehiclename: this.customer.vehiclename.trim(),
        //vehiclename: this.vehiclenametext == false ? this.customer.vehiclename.key : this.customer.vehiclenametext.trim(), 

        vehiclename: this.vehiclenametext == false ? this.customer.vehiclename == '' || this.customer.vehiclename == null || this.customer.vehiclename == undefined || this.customer.vehiclename == 'null' || this.customer.vehiclename == 'undefined' ? this.vehicleName_id : this.customer.vehiclename : this.customer.vehiclenametext.trim(),

        fueltype: this.customer.fueltype == '' || this.customer.fueltype == null || this.customer.fueltype == undefined || this.customer.fueltype == 'null' || this.customer.fueltype == 'undefined' ? this.fuelType_id : this.customer.fueltype,
        // vehicleno_prefix:`${this.customer.vehicleno_prefix}`,

        driving_license: `${this.customer.driving_license.trim()}`,
        // driver_contracter_name:`${this.customer.driver_contracter_name}`,
        // contracter_emailid: `${this.customer.contracter_emailid}`,
        vehicletype: this.customer.vehicletype.trim(),

        vehicletypesize: this.vehicletypesizetext==false ? (this.customer.vehicletypesize == '' || this.customer.vehicletypesize == null || this.customer.vehicletypesize == undefined || this.customer.vehicletypesize == 'null' || this.customer.vehicletypesize == 'undefined' ? `${this.vehicleTypeSize_id}` : `${this.customer.vehicletypesize}`):this.customer.vehicletypesizetext.trim()+"ft",

        registration_no : this.customer.registration_no.trim(),
        //vehiclemake: this.customer.vehiclemake.trim(),
        vehicleweightcarrying: this.customer.vehicleweightcarrying.trim(),
        vehiclephysicalweight: this.customer.vehiclephysicalweight.trim(),
        // vehicledimensionsweight :this.customer.vehicledimensionsweight.trim(),
        // editvehicleno:this.customer.editvehicleno,
        contractormobilenumber: this.customer.contractormobilenumber!=null || this.customer.contractormobilenumber!=undefined || this.customer.contractormobilenumber !="" ? this.customer.contractormobilenumber.trim():'',
        helperfirstname: this.customer.helperfirstname.trim(),
        helperlastname: this.customer.helperlastname.trim(),
        helpermobilenumber: this.customer.helpermobilenumber.trim(),
        helperaltmobilenumber: this.customer.helperaltmobilenumber.trim(),
        // drivercontractername: this.customer.driver_contracter_name.trim(),
        drivercontractername: this.customer.driver_contracter_name!=null || this.customer.driver_contracter_name!=undefined || this.customer.driver_contracter_name !=""?this.customer.driver_contracter_name.trim():'',
        contracter_emailid:this.customer.contracter_emailid!=null || this.customer.contracter_emailid!=undefined || this.customer.contracter_emailid !="" ? this.customer.contracter_emailid.trim():'',
        transporter_id :  this.transporterCompanyName.key=='' || this.transporterCompanyName.key == null || this.transporterCompanyName.key == undefined || this.transporterCompanyName.key == 'null' || this.transporterCompanyName.key == 'undefined' ? this.transporter_id:this.transporterCompanyName.key,
        helper_data:this.helper_data,
        transporter_company_name:this.transporterCompanyName.label?this.transporterCompanyName.label.trim():this.transporterCompanyName.trim(),
        transporter_gstnumber:`${this.customer.transporter_gstnumber==null || this.customer.transporter_gstnumber==undefined || this.customer.transporter_gstnumber==''?'':this.customer.transporter_gstnumber.trim()}`,
        driver_data:this.driver_data,
       // oldpayload:[this.oldvehicledata],
        oldvehicletype:this.getoldvehicletype,
        logcommentdata:ologcommentdata ? ologcommentdata : "",
        getfullname:this.getfullname,
        paymenttype:this.customer.paymenttype,

        pincode: this.customer.pincode ? this.customer.pincode : '',
        address: this.customer.address ? this.customer.address : '',
        city: this.customer.city ? this.customer.city : '',
        state: this.customer.state ? this.customer.state : '',
        pan: this.customer.pan ? this.customer.pan : '',
        bankname: this.customer.bankname ? this.customer.bankname : '',
        bankaccountname: this.customer.bankaccountname ? this.customer.bankaccountname : '',
        branchname: this.customer.branchname ? this.customer.branchname  : '',
        accountnumber: this.customer.accountnumber ? this.customer.accountnumber : '',
        ifsccode: this.customer.ifsccode ? this.customer.ifsccode : '',
        aadhar: this.customer.aadhar? this.customer.aadhar : '',
        vendortype: this.customer.vendortype ? this.customer.vendortype : '',
        bankcancelledcheque: this.customer.bankcancelledcheque ? this.customer.bankcancelledcheque : '',
        gstincertificate: this.gstincertificate ? this.gstincertificate : '',
        hubid:userInfo.user_type=='2'?userInfo.hub_id:(this.adminHub?this.adminHub.key:""),
        usertype:userInfo.user_type,
        sysusermasterid:[`${userInfo.sysusermasterid}`],
        labour_charges: this.customer.labour_charges ? this.customer.labour_charges : null,
        fixed_kms: this.customer.fixed_kms ? `${this.customer.fixed_kms}` : null,
        fixed_freightrate: this.customer.fixed_freightrate ? this.customer.fixed_freightrate : null,
        extra_kmrate: this.customer.extra_kmrate ? this.customer.extra_kmrate : null,
        workingdays: this.customer.workingdays ? this.customer.workingdays : null,
        puc_url:this.customer.puc_url ? this.customer.puc_url:null,
        insurance_url:this.customer.insurance_url ?this.customer.insurance_url:null,
        registration_url:this.customer.registration_url ?this.customer.registration_url:null,
        permit_url:this.customer.permit_url ?this.customer.permit_url:null
      };
      console.log("Hiiii", passwObj);
      // return false;
      // if (typeof this.customer.deliveryagentmasterid !== "undefined") {
      //DAUpdateVehicleDetail
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/updatevehicledetailsNew`, passwObj)
        .then((result) => {
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            console.log('his.editAgentMaster=============>',this.editAgentMaster)
            this.$fire({
              text: "Updated Successfully",
              type: "success",
              timer: 30000,
            })
            this.editAgentMaster=false;
             this.customer = {};
            this.displaydata();
            this.getVehicleDetailsList();
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 300000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    updateDeliveryAgentAdhoc: function() {
      document.getElementById("overlayModal").style.display = "block";
      var result = [];
      // alert("innnn");
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);


      console.log('this.customer============>',this.customer)
      if (this.userType==1) {
        console.log("===",this.adminHub && this.adminHub.key)
        if (this.adminHub && this.adminHub.key) {
           console.log("===",this.adminHub && this.adminHub.key)
        }
        else{
            this.$fire({
              text: "Please Select Hub",
              type: "warning",
              timer: 30000,
            });
            document.getElementById("overlayModal").style.display = "none";
            return false;
        }
      }
      else{
        var systemUserid = [];
            systemUserid = this.userType
       }
   //   console.log('this.customer.altmobile_no===>',this.customer.altmobile_no)
     // console.log(' this.customer.mobile_no=====>', this.customer.mobile_no)
      // if (this.customer.altmobile_no == this.customer.mobile_no) {
      //   // alert("Alternate Mobile Number should be different from Mobile Number");
      //   this.$fire({
      //     text:
      //       "For Driver Alternate Mobile Number should be different from Mobile Number",
      //     type: "warning",
      //     timer: 30000,
      //   });
      //   document.getElementById("overlayModal").style.display = "none";
      //   return false;
      // }

      // if ( this.customer.helperaltmobilenumber == this.customer.helpermobilenumber ) {
      //   // alert("Alternate Mobile Number should be different from Mobile Number");
      //   this.$fire({
      //     text:
      //       "For Helper Alternate Mobile Number should be different from Mobile Number",
      //     type: "warning",
      //     timer: 30000,
      //   });
      //   document.getElementById("overlayModal").style.display = "none";
      //   return false;
      // }

      /*if (this.valueAdmin.length > 0) {
          var systemUserid = [];
          systemUserid = this.valueAdmin.toString().split(",");
      }
      else{
          this.$fire({
            text: "Please Select Admin",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlayModal").style.display = "none";
          return false;
      }

      if (this.valueWHAdmin.length > 0) {
          var selctWarehouseid = [];
          selctWarehouseid = this.valueWHAdmin.toString().split(",");
      }
      else{
        this.$fire({
          text: "Please Select City",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlayModal").style.display = "none";
        return false;
      }*/
      if(this.transporterCompanyName==null){
          document.getElementById("overlayModal").style.display = "none";
          this.$fire({
          text:"Please Select Transporter Company",
          type: "warning",
          timer: 30000,
          });
          return false;  
        }


        this.customer.vehicletypesize = this.customer.vehicletypesize
        let vehicletypesizetext = this.customer.vehicletypesize && typeof this.customer.vehicletypesize =='object' ?  this.customer.vehicletypesize.label :this.customer.vehicletypesize

        let ologcommentdata = this.comparePayloadsWithKeyMap(this.oldvehicledata,this.customer,this.regularkeyMap)
        this.customer.vehicletypesize = this.vehicleTypeSize_id

        this.driver_data.push({
          driverfirstname: this.customer.driverfirstname?this.customer.driverfirstname.trim():this.customer.driverfirstname,
          driverlastname: this.customer.driverlastname?this.customer.driverlastname.trim():this.customer.driverlastname,
          drivermobilenumber: this.customer.mobile_no,
          driveraltmobilenumber: this.customer.altmobile_no,
          driving_license: this.customer.driving_license?this.customer.driving_license.trim():this.customer.driving_license,
          driver_license_photo:'',
          driver_license_criteria:'',
          driver_email:'',
          driver_adhar_no:'',
          driver_emergency_no:'',
          driver_adhar_photo:'',
          driver_language:[],
          driver_qualification:[]
        });
        this.helper_data.push({
            helperfirstname: this.customer.helperfirstname?this.customer.helperfirstname.trim():this.customer.helperfirstname,
            helperlastname: this.customer.helperlastname?this.customer.helperlastname.trim():this.customer.helperlastname,
            helpermobilenumber: this.customer.helpermobilenumber?this.customer.helpermobilenumber.trim():this.customer.helpermobilenumber,
            helperaltmobilenumber: this.customer.helperaltmobilenumber?this.customer.helperaltmobilenumber.trim():this.customer.helperaltmobilenumber,
            helper_license_number:"",
            helper_license_photo:"",
            helper_license_criteria:"",
            helper_email:"",
            helper_adhar_no:"",
            helper_adhar_photo:""
          });
        console.log("this.helper_data",this.helper_data);
      var passwObj = {
        adhockpayload: {
          vehicleid: `${this.customer.vehicleMasterid}`,
          vehicleno: this.customer.editvehicleno?this.customer.editvehicleno.trim():this.customer.editvehicleno,
          lastmodifiedby: userInfo.sysemailid?`${userInfo.sysemailid.trim()}`:userInfo.sysemailid,
          driverfirstname: this.customer.driverfirstname?this.customer.driverfirstname.trim():this.customer.driverfirstname,
          driverlastname: this.customer.driverlastname?this.customer.driverlastname.trim():this.customer.driverlastname,
          drivermobilenumber: this.customer.mobile_no?this.customer.mobile_no.trim():this.customer.mobile_no,
          driveraltmobilenumber: this.customer.altmobile_no,
          vehiclename: this.customer.vehiclename?this.customer.vehiclename.trim():this.customer.vehiclename,
          // vehicleno_prefix:`${this.customer.vehicleno_prefix}`,

          driving_license: this.customer.driving_license?`${this.customer.driving_license.trim()}`:this.customer.driving_license,
          // driver_contracter_name:`${this.customer.driver_contracter_name}`,
          contracter_emailid: this.customer.contracter_emailid?`${this.customer.contracter_emailid.trim()}`:this.customer.contracter_emailid,
          vehicletype: "adhoc",
          registration_no: this.customer.registration_no?this.customer.registration_no.trim():this.customer.registration_no,
          // vehiclemake: this.customer.vehiclemake.trim(),
          
          // vehicleweightcarrying: this.customer.vehicleweightcarrying.trim(),
          // vehiclephysicalweight: this.customer.vehiclephysicalweight.trim(),
          // vehicledimensionsweight: this.customer.vehicledimensionsweight?this.customer.vehicledimensionsweight.trim():this.customer.vehicledimensionsweight,
          // editvehicleno:this.customer.editvehicleno,
          helper_data:this.helper_data,
          contractormobilenumber: this.customer.contractormobilenumber,

          // drivercontractername: this.customer.driver_contracter_name.trim(),
          drivercontractername: this.customer.driver_contracter_name!=null || this.customer.driver_contracter_name!=undefined || this.customer.driver_contracter_name !=""?this.customer.driver_contracter_name.trim():'',
          contracter_emailid: this.customer.contracter_emailid.trim(),
          sysusermasterid: systemUserid,
        //  warehouseid : selctWarehouseid,
          // transporter_id :  this.customer.transporter_id,
          transporter_id :  this.transporterCompanyName.key=='' || this.transporterCompanyName.key == null || this.transporterCompanyName.key == undefined || this.transporterCompanyName.key == 'null' || this.transporterCompanyName.key == 'undefined' ? this.transporter_id:this.transporterCompanyName.key,
          transporter_company_name:this.transporterCompanyName.label?this.transporterCompanyName.label:this.transporterCompanyName,
          transporter_gstnumber:this.customer.transporter_gstnumber==null||this.customer.transporter_gstnumber==undefined || this.customer.transporter_gstnumber==''?'':this.customer.transporter_gstnumber.trim(),
          driver_data:this.driver_data,
       // vehicletypesizetext:this.customer.vehicletypesize,
        // sysusermasterid:this.sysIdinlist,
        // warehouseid: this.WHid, 
        //oldpayload:[this.oldvehicledata],
        oldvehicletype:this.getoldvehicletype,
        logcommentdata:ologcommentdata ? ologcommentdata : "",
        getfullname:this.getfullname,
        fueltype: this.customer.fueltype == '' || this.customer.fueltype == null || this.customer.fueltype == undefined || this.customer.fueltype == 'null' || this.customer.fueltype == 'undefined' ? this.fuelType_id : this.customer.fueltype,

      //  vehicletype: this.customer.vehicletype.trim(),
      vehicletypesize: this.customer.vehicletypesize,
      vehicletypesizetext:vehicletypesizetext,
      hubid:userInfo.user_type=='2'?userInfo.hub_id:(this.adminHub?this.adminHub.key:""),
      usertype:userInfo.user_type
        },
      };

      //console.log('this.customer.vehicletypesize.key===========>>>',this.customer.vehicletypesize)

      //console.log('vehicleTypeSizeOptions=========>',this.vehicleTypeSizeOptions)
      console.log("Hiiii", passwObj);
      // return false;
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/editAdhocVehicleTypetoInterIntra`,
          passwObj
        )
        .then((result) => {
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            // alert("Updated Successfully");
            this.$fire({
              text: "Updated Successfully",
              type: "success",
              timer: 30000,
            });
           // window.location.reload(true);
            this.customer = {};
            this.displaydata();
           // this.editAgentMaster = !this.editAgentMaster;
            this.editcancel()
            // this.$router.push("/vehicleMaster");
          } else {
            // Utils.notify(result.body.returnvalue, "error");
            // alert(result.body.returnvalue);
            // this.$alert(result.body.returnvalue);
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 300000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    editvehicleCityWH: function(value) {
      console.log("Value",value);
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.valueAdmin = [];
      this.optionsAdmin = [];
      this.warehouseData = [];
        this.warehouseAdmin = [];
        this.valueWHAdmin=[];
        this.vehicleCityWHmodal = true;
      this.vehicle_Id = value.vehicle_id;
      this.sysIdinlist = value.sysusermasterid;
      this.WHid = value.warehouseid;
      // console.log("this.vehicle_Id=value.vehicle_id;",this.sysIdinlist);
      this.vehicle_Id = value.vehicle_id;

      if (this.WHid !=null) {
        this.adminWHid = this.WHid.split(",");
        console.log("YYYYYYYYYY", this.adminWHid);
        for (let i = 0; i < this.adminWHid.length; i++) {
          this.valueWHAdmin.push(this.adminWHid[i]);
        }
        console.log("this.valueWHAdmin",this.valueWHAdmin)
      }
      if (this.sysIdinlist != null) {
        this.adminSysid = value.sysusermasterid.split(",");
        // console.log("YYYYYYYYYY", this.adminSysid);
        for (let i = 0; i < this.adminSysid.length; i++) {
          this.valueAdmin.push(this.adminSysid[i]);
        }
      }

      const Obj = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
      };
      console.log("Obj", Obj);
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/adminListingForVehicle`, Obj)
        .then((result) => {
          console.log("YYY", result);
          if (result.body.returnmsg === "Successful") {
            this.adminData = result.body.returnvalue;
            for (let i = 0; i < this.adminData.length; i++) {
              let admin = {
                name:
                  this.adminData[i].userfirstname +
                  "" +
                  this.adminData[i].userlastname +
                  " - " +
                  (this.adminData[i].user_type == 2 ? "Admin" : "Super Admin"),
                id: this.adminData[i].sysusermasterid.toString(),
              };

              this.optionsAdmin.push(admin);
              // console.log("HHHHAAAA",this.optionsAdmin);
            }
            // console.log(this.optionsAdmin);
          } else {
            this.adminData = result.body.returnvalue;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    
    selectAdmin: function() {
      this.valueAdmin;
      this.valueAdmin.toString();
      this.editWiseWarehouseList();
           
    },

    editWiseWarehouseList: function() {
      this.sendadminid = this.valueAdmin.toString().split(",");

      // if (this.valueAdmin != null) {
      //   this.adminWHid = this.WHid.split(",");
      //   console.log("YYYYYYYYYY", this.adminWHid);
      //   for (let i = 0; i < this.adminWHid.length; i++) {
      //     this.valueWHAdmin.push(this.adminWHid[i]);
      //   }
      //   console.log("this.valueWHAdmin",this.valueWHAdmin)
      // }
     

      if (this.valueAdmin.length>0) {
        
        const Obj = {
          sysusermasterid:  this.sendadminid,
        };
        console.log("Obj", Obj);
        
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAdminWiseWarehouseList`, Obj)
        .then((result) => {
          console.log("result",result)
          if (result.body.returnmsg === "Successful") {
            this.warehouseAdmin = [];
            this.warehouseData = result.body.returnvalue;
            // console.log("oooooooooooooooooooooooooooooooooooooooooooooooo")
            for (let i = 0; i < this.warehouseData.length; i++) {
              // console.log("oooooooooooooooooooooooooooooooooooooooooooooooo")
              let whadmin = {
                name_wh: this.warehouseData[i].city + ' - ' + this.warehouseData[i].warehousename,
                id_wh: this.warehouseData[i].warehouseid,
              };
              this.warehouseAdmin.push(whadmin);
              // console.log("warehouseAdmin",this.warehouseAdmin)
            }
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
      } 
      else{
        this.warehouseData = [];
        this.warehouseAdmin = [];
        this.valueWHAdmin = [];
      }
    },

    selectWHAdmin: function() {
        var systemUserid = [];
        this.valueWHAdmin;
        this.valueWHAdmin.toString();
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.changeVehicleCityWH();
        }
      });
    },

    changeVehicleCityWH: function() {
      document.getElementById("overlayModal").style.display = "block";
      let userData = localStorage.getItem("userData");
      let userInfo = JSON.parse(userData);
      let obj = {
        vehicleid: this.vehicle_Id,
        sysusermasterid: this.valueAdmin,
        lastmodifiedby:
          `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
          warehouseid : this.valueWHAdmin,
        // sysusermasterid:`${userInfo.sysusermasterid}`,
        // usertype:`${userInfo.user_type}`,
      };
      console.log("OOOOOO", obj);
      // return false;
      this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/updateCityAndWarehouseForVehicle`,
          obj
        )
        .then((result) => {
          console.log(result.body);
          // this.isBusy = false;
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: "Admin Updated Successfully",
              type: "success",
              timer: 30000,
            });
            this.displaydata();
            this.vehicleCityWHmodal = false;
          } else {
            this.$fire({
              text: result.body.returnmsg,
              type: "warning",
              timer: 30000,
            });
            // this.editCity=false;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    editCityWHcancel: function(value) {
      // console.log("Value",value);
      this.vehicleCityWHmodal = false;
    },

    isJson: function(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },

    editAgentMasterModal: function(value) {
      this.customer.deliveryagentpassword = value.deliveryagentpassword;
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
    },

    toggleInfoModal: function(value) {
      this.customer = value;

      this.toggleInfo = !this.toggleInfo;
    },

    activateInActivateDeliveryAgent: function(value) {
      var activeInactiveVal;
      if (this.customer.isactive === "1") {
        activeInactiveVal = "0";
        // console.log("activeInactiveVal",activeInactiveVal);
      } else {
        activeInactiveVal = "1";
        // console.log("activeInactiveVal1",activeInactiveVal);
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        // deliveryagentmasterid: deliveryagentmasterId,
        vehicleMasterid: this.customer.vehicle_id,
        isactive: activeInactiveVal,
        lastmodifiedby:
          `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
      };
      console.log("JJJJJJJJ", customerGetobj);
      // return false;
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/activateinactivatedeliveryagent`,
          customerGetobj
        )
        .then((result) => {
          console.log("result", result);
          if (result.body.returnmsg === "Successfull") {
            // alert("Shipments are Allocated so can not InActive");
            this.$fire({
              text: "Status Changed Successfully",
              type: "success",
              timer: 30000,
            });

            this.toggleInfo = false;
            this.displaydata();
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
            this.toggleInfo = false;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
      //  this.displaydata();
      // alert("Status changed successfully");
    },

    changePassword(value) {
      this.vehicle_id = "";
      // alert("innnn");
      // console.log("Value",value);
      this.vehicle_id = value.vehicle_id;

      this.resetPassword = true;
    },

    cancelPassword() {
      this.sysusermasterid = "";
      this.customer = {};
      this.resetPassword = false;
    },

    changevehiclestatus(value){
      console.log(value)

      this.avilablevehicle = value.is_available;
      console.log("this.avilablevehicle",this.avilablevehicle)
      var activeInactiveVal;
      if (value.is_available == "No") {
        activeInactiveVal = "yes";
      } else {
        activeInactiveVal = "No";
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        vehicle_id: value.vehicle_id,
        is_available: activeInactiveVal,
      };
      console.log("JJJJJJJJ", customerGetobj);
      // return false;
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/makeVehicleAvailable`,
          customerGetobj
        )
        .then((result) => {
          console.log("result", result);
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: "Status Changed Successfully",
              type: "success",
              timer: 30000,
            });

            this.displaydata();
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
  
    },

    availablevehiclelist(){
      this.availablevehiclemodel = !this.availablevehiclemodel
      this.isBusyvlist = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const obj = {};

      // return false;
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/getAvailableVehicle`,
          obj
        )
        .then((result) => {
          console.log("result", result);
          this.isBusyvlist = false;
          if (result.body.returnmsg === "Successful") {
            this.available_vehiclelist = result.body.returnvalue;
            console.log("@@@@@@@", this.available_vehiclelist)

            this.totalvehiclelist = result.body.returnvalue.length;
            console.log(this.totalvehiclelist)
          } else {
            this.available_vehiclelist = [];
            this.totalvehiclelist = 0;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    checkGSTlength(value){
      if (value.length>0) {
          this.showverifybutton=true;
          document.getElementById("submitButton").disabled = true; 
        }
      else{
        this.showverifybutton=false;
        this.customer.transporter_gstnumber='';
        this.errors_GST = false;
        this.errors_showGST= {};
        document.getElementById("submitButton").disabled = false;
        this.removeGST=false;
      }
    },

    verifyGSTNo(){
      document.getElementById("overlayModal").style.display = "block";
      const infoObj = {
        Gstin:this.customer.transporter_gstnumber.trim(),
      };
      console.log("infoObj",infoObj);
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
        console.log("result",result)
        document.getElementById("overlayModal").style.display = "none";
        if (result.body === "success") {
          document.getElementById("submitButton").disabled = false;
          this.showverifybutton=false;
          this.$fire({
            text: 'Successful Verify',
            type: "success",
            timer: 30000,
          });
          this.errors_GST = false;
          this.errors_showGST.transporter_gstnumber=''
          this.removeGST=false;
        } else {
          this.errors_GST = true;
          this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
          this.removeGST=true;
        }
      }).catch((ex) => {
        console.log("error", ex);
      });
      // if (this.customer.transporter_gstnumber) {
      //     this.errors_GST = true;
      //     this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
      //     this.removeGST=true;
      //     return false;
      // }
      // else{
      //   this.showverifybutton=false;
      //   document.getElementById("submitButton").disabled = false;
      // }
    },

    removevalue(){
      this.showverifybutton=false;
      this.customer.transporter_gstnumber='';
      this.errors_GST = false;
      this.errors_showGST= {};
      document.getElementById("submitButton").disabled = false;
      this.removeGST=false;
    },

    EmailListing(id){
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);

          let obj = { status:"Approved",
            isactive : '1'
           }

          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterEmailIdListNew`,obj)
          .then(result => {
              if(result.body.returnmsg === "Successful"){
              this.mailitems  = result.body.returnvalue;
              console.log("mailitems",this.mailitems);
              var data = [];
  
              this.mailitems.forEach(function (srData) {
                  data.push({
                  key:srData.transporter_id,
                  label:srData.transporter_company_name
                  });
              });
              this.optionmailid = data;
                console.log("optionmailid sangam--->", this.optionmailid);
                this.otransporteremail = data
                this.customer.optionmailid = data;

                let getfilterdata = this.mailitems.filter(i=>i.transporter_id == id)


                 this.customer.contracter_emailid = getfilterdata.length > 0 ? getfilterdata[0].transporter_emailid : null
              }
              else{
                this.mailitems=[];
                this.optionmailid = [];
              }

          }).catch(ex => {
            console.log('error', ex)
          })
    },
    EmailListingv1(transporter_id){
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);

          let obj = { status:"Approved",transporter_id:Number(transporter_id) }

          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterEmailIdListv1`,obj)
          .then(result => {
              if(result.body.returnmsg === "Successful"){
              this.mailitems  = result.body.returnvalue;
              console.log("mailitems",this.mailitems);
              var data = [];
  
              this.mailitems.forEach(function (srData) {
                  data.push({
                  key:srData.transporter_id,
                  label:srData.transporter_company_name
                  });
              });
              this.optionmailid = data;
                console.log("optionmailid sangam--->", this.optionmailid);
                this.otransporteremail = data
                this.customer.optionmailid = data;
                this.customer.contracter_emailid = this.mailitems[0].transporter_emailid
                //customer.contracter_emailid

              }
              else{
                this.mailitems=[];
                this.optionmailid = [];
              }

          }).catch(ex => {
            console.log('error', ex)
          })
    },
    updateTextbox() {
            let transporterObj={};
            if(this.transporterCompanyName!=null){
                for(let i=0;i<this.mailitems.length;i++){
                if(this.transporterCompanyName.key===this.mailitems[i].transporter_id){
                    transporterObj={
                        transporter_id:this.mailitems[i].transporter_id,
                        transporter_name:this.mailitems[i].transporter_name,
                        transporter_emailid:this.mailitems[i].transporter_emailid,
                        transporter_mobilenumber:this.mailitems[i].transporter_mobilenumber,
                        // transporter_gstnumber:this.mailitems[i].transporter_gst_no
                        transporter_gstnumber:this.mailitems[i].transporter_gst_no == undefined || this.mailitems[i].transporter_gst_no == 'undefined' ? '' : this.mailitems[i].transporter_gst_no
                    }
                }
            }
            this.transporterObj=transporterObj;
            console.log("this.transporterObj",this.transporterObj);
            this.updateData(transporterObj);
            }
    },
    
    updateData(transporterObj){
      // this.transporterCompanyName=
      this.customer.contracter_emailid=transporterObj.transporter_emailid;
      this.customer.driver_contracter_name=transporterObj.transporter_name;
      this.customer.contractormobilenumber=transporterObj.transporter_mobilenumber;
      this.customer.transporter_gstnumber=transporterObj.transporter_gstnumber;
            
    },
    getPincodeList:function(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={}
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPincode`, Obj)
            .then((result)=>{
                if(result.body && result.body.returnmsg== "Successful"){
                    this.pincodeCityData = result.body.returnvalue;                    
                    for(let i=0;i<this.pincodeCityData.length;++i){
                        this.pincodes.push({
                            key:this.pincodeCityData[i].pincode,
                            label:this.pincodeCityData[i].pincode
                        })
                    }
                    console.log("pincodes-->",this.pincodes) 
                }
                else{
                    this.pincodes=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
    pincodeChange(data) {        
      let pincode = ''
      if(data) {
        if(!data.label){
          pincode = data
        }else{
          pincode = data.label
        }      

        console.log('this.customer',this.customer.pincode);
        this.$set(this.customer, 'pincode', pincode);
        this.$set(this.customer, 'city', '');
        this.$set(this.customer, 'state', '');
          if (pincode) {
            const selectedPincode = this.pincodeCityData.find(
                item => item.vendorpincode == pincode
            );

              if (selectedPincode) {
                  this.$set(this.customer, 'city', selectedPincode.vendorcity);
                  this.$set(this.customer, 'state', selectedPincode.vendorstate);
              }
          }
        }
          
      },
      driverLicenseFileUplod(event) {
        this.selectedDl = event.target.files[0];
        if (this.selectedDl) {
          this.dlFileName = `${event.target.files[0].name}`;
        }
        this.dlFileType = this.selectedDl.type;
        this.uploadDL(this.selectedDl);
      },
      uploadDL: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.selectedDl)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.licence_url = response.data.image_url;
          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error In licence check', e);
        })
      },
      pucFileUplod1(event) {
        this.pucFileUplod = event.target.files[0];
        if (this.pucFileUplod) {
          this.pucFileUplodFilename = `${event.target.files[0].name}`;
        }
        this.pucFileUplodType = this.pucFileUplod.type;
        this.uploadPuc(this.pucFileUplod);
      },
      uploadPuc: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.pucFileUplod)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.puc_url = response.data.image_url;
            this.customer.puc_url= response.data.image_url;
          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error In Upload Bank check', e);
        })
      },
      registrationFileUplod(event) {
        this.selectedRegistration = event.target.files[0];
        if (this.selectedRegistration) {
          this.registrationFilename = `${event.target.files[0].name}`;
        }
        this.registrationFileType = this.selectedRegistration.type;
        this.uploadRegisterFile(this.selectedRegistration);
      },
      uploadRegisterFile: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.selectedRegistration)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.registration_url = response.data.image_url;
            this.customer.registration_url=response.data.image_url;
          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error in upload register certificate', e);
        })
      },
      insuranceFileUplod(event) {
        this.selectedInsuranceFile = event.target.files[0];
        if (this.selectedInsuranceFile) {
          this.registrationFilename = `${event.target.files[0].name}`;
        }
        this.registrationFileType = this.selectedInsuranceFile.type;
        this.uploadInsuranceFile(this.selectedInsuranceFile);
      },
      uploadInsuranceFile: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.selectedInsuranceFile)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.insurance_url = response.data.image_url;
            this.customer.insurance_url = response.data.image_url;            
          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error in upload register certificate', e);
        })
      },
      permitFileUplod(event) {
        this.selectedPermit = event.target.files[0];
        if (this.selectedPermit) {
          this.permitFileName = `${event.target.files[0].name}`;
        }
        this.permitFileType = this.selectedPermit.type;
        this.uploadPermitFile(this.selectedPermit);
      },
      uploadPermitFile: function() {
        document.getElementById("overlayModal").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);
        let data = new FormData();
        data.append('file', this.selectedPermit)
        axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`, data, {
          header: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          document.getElementById("overlayModal").style.display = "none";

          if (response.data.result == 'success') {
            this.$fire({
              text: "File Uploaded",
              type: "success",
              timer: 300000
            })
            this.permit_url = response.data.image_url;
            this.customer.permit_url = response.data.image_url;

            
          } else {
            this.$fire({
              text: "File Not Uploaded",
              type: "error",
              timer: 300000
            })
          }
        }).catch(e => {
          console.log('Error In Upload Permit File', e);
        })
      },
    VehicleListingLog(){
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);

          let obj = { vehicleid:Number(this.getmyvehicleid) }

          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllVehiclelogMaster`,obj)
          .then(result => {
              if(result.body.returnmsg === "Successful"){
                this.vehicle_historylog = result.body.returnvalue;
                
            //  console.log('vehicle_historylog=========>',this.vehicle_historylog)
              }

              else{
                this.vehicle_historylog=[];
               }

          }).catch(ex => {
            console.log('error', ex)
          })
    },
    compareArrays(oldArray, newArray) {
const diffKeys = [];

 const targetKeys = [
  'vehicle_no',
  'drivercontractername',
  'helperaltmobilenumber',
  'contractormobilenumber',
  // 'vehicledimensionsweight',
  'transporter_company_name'
];

 const flattenObject = (obj, prefix = '') =>
  Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? `${prefix}.` : '';
    if (typeof obj[k] === 'object' && obj[k] !== null && !Array.isArray(obj[k])) {
      Object.assign(acc, flattenObject(obj[k], pre + k));
    } else {
      acc[pre + k] = obj[k];
    }
    return acc;
  }, {});

const oldObj = oldArray[0];
const newObj = newArray[0];

const flatOldObj = flattenObject(oldObj);
const flatNewObj = flattenObject(newObj);

targetKeys.forEach(key => {
  if (flatOldObj[key] !== flatNewObj[key]) {
    diffKeys.push(key);
  }
});

let string = diffKeys.reduce((acc, item, index) => {
  return acc + item + ((index % 2 === 1) ? ",\n" : ", ");
}, "").trim(); 

return string;
},
comparePayloadsWithKeyMap(oldPayload, newPayload, keyMap) {
  const changes = [];

  for (const key in newPayload) {
    if (newPayload.hasOwnProperty(key) && key !== "optionmailid") {
      if (newPayload[key] !== oldPayload[key]) {
        const mappedKey = keyMap[key] || ""; 
         if(mappedKey){
        changes.push(mappedKey);
         }
      }
    }
  }

  const uniqueArray = [...new Set(changes)];

return uniqueArray.join(", ");
 // return changes.join(", ");
}

    
  },

  filters: {
    datechange: function(value) {
      if (value == null) {
        return "-";
      } else {
        var d = new Date(value);
        var curr_date = (d.getDate() < 10 ? "0" : "") + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? "0" + month : "" + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return (
          curr_date + "-" + curr_month + "-" + curr_year + "  " + " " + strTime
        );
      }
    },
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
};
</script>

<style >
.modal-title{
 width:100%!important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.custom-scrollbar {
  position: relative;
  height: 200px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
.racktd {
  text-align: center;
  font-weight: bold;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
#vendor_list_scroll {
  max-height: 500px;
  overflow-y: scroll;
}
#table {
  text-align: left;
  position: relative;
  border-collapse: collapse;
}
#th_style {
  background: #eceff1;
  position: sticky;
  top: 0;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}
.masterAction {
  width: 100px;
}
.vehiclename {
  width: 80px;
}
#overlayModal {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.loaderModal {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*.volume{
  width: 55px !important;
}*/
/*.physicalweight{
  width: 80px;
}*/
/*.swal2-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
}*/
.toggle-wrapper {
display: flex;
/* align-items: center; */
gap: 10px; /* Space between label and toggle button */
}

.toggle-label {
font-size: 14px; /* Adjust font size as needed */
margin-right: 10px; /* Space between label and button */
}

.toggle-circle {
width: 60px;
height: 30px;
background-color: #ddd;
border-radius: 30px;
position: relative;
cursor: pointer;
border: 2px solid #bbb;
transition: background-color 0.3s;
}

.toggle-active {
background-color: #4caf50; /* Green color for active state */
}

.toggle-inactive {
background-color: #c5bfbe; /* Red color for inactive state */
}

.toggle-handle {
width: 26px;
height: 26px;
background-color: white;
border-radius: 50%;
position: absolute;
top: 0px;
left: 0px;
transition: transform 0.3s;
}

.toggle-active .toggle-handle {
transform: translateX(30px); /* Moves handle to the right */
}

.toggle-inactive .toggle-handle {
transform: translateX(0); /* Keeps handle at the left */
}


.update-info {
margin-top: 20px; /* Adjust margin as needed */
}


</style>
